<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1920 1080"
    xml:space="preserve"
    class=""
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M587.5 317.4v-.9l3.1-3.1h1l-4.1 4"
    />
    <path fill="#fff9e7" d="m661 728 3.1 13.1L793.9 929 1113 728z" />
    <path
      d="M1539.5 118.8a30.2 30.2 0 0 0-9.5-7.4 30.8 30.8 0 0 0-11.9-2.5L234.6 125.4a20.2 20.2 0 0 0-19.5 15.9c-.4 1.8-.5 3.6-.3 5.4a19.3 19.3 0 0 0 3.7 10.1l598 823.3L1744 371.5l-204.5-252.7zM796.7 924 668.5 747.3l-3-12.3h446.4L796.7 924z"
      fill="#fff9e7"
    />
    <path
      fill="#eadb9d"
      d="m1251 642.7-1.1-121.7-478.3 12.2L733 714.7 939.1 735h136.1l69-94.4zM989.7 740h81.8l3.7-5H939.1zM1183 229h18V112.7l-18 .2zM1394 229h40V109.7l-40 .5zM786.9 137l-531.7 10-8.2 11.7L553.2 581l27.5-9-115.3-205-89.8-119-26.5-38-17.4-28 460.3 4z"
    />
    <path fill="#eadb9d" d="M805 139h704v174H805z" />
    <path
      fill="#eadb9d"
      d="m1424 310-199 144 18 160 25 4 208-112 40-32 2-17-5-13 10.9-5.7 19.1-1.3-21-140zM780 678h33V117.6l-33 .4zM663 737h39.6L578 574l-30 1 118 179 3.1-.4-3.1-4.3z"
    />
    <path
      fill="#e9eadf"
      d="M838 794h163v109H838zM1290 636l427-260-76-98-91 100-273 209-62 16 7 82z"
    />
    <path
      d="M789.8 205.4a38.3 38.3 0 0 0-14.2-27.7c-9.2-6.6-21.3-7.4-32.8-7.9-68.1-2.8-136.3-5.7-204.3-1.4-18.2 1.2-36.5 2.8-54.7 2.7-24.6-.2-49.1-3.7-73.8-4.4-36.8-1.1-73.4 4.1-109.8 9.3-1.4 16.4 10.4 30.6 20.7 43.6 10 12.7 19.2 26.1 26.1 40.6 4.7 9.8 8.4 20.2 15.1 28.8 5 6.5 11.6 11.7 17.6 17.4 21.9 20.7 37.2 47.3 58.6 68.5 11.7 11.5 25.2 21.4 35.1 34.4 9.1 11.9 14.9 25.8 20.9 39.4C514.6 494 541.7 540 586.6 563l.9-1.8c16.8 5 34-5.2 51.4-7.4 12.5-1.6 25 1 37.4 2.9 28.6 4.2 57.6 4.4 86.5 4.5 6.3 0 13.3-.2 17.7-4.5 3.4-3.3 4.4-8.2 5.1-12.9 16.3-101.2-11.3-205 2-306.6 1.4-10.6 3.2-21.3 2.2-31.8z"
      fill="#c9d3b6"
    />
    <path
      d="m462.4 382.2-.7-.7-1.8-1.5 2.5 2.2zM505.2 401.2c11.7-.6 22.2-7.2 33.6-10.2 26.8-6.9 53.9 6.8 80.5 14.5 28.1 8.2 57.7 9.7 86.9 11.2 7.9.4 18-.5 20.6-8 2.1-5.9-2.4-12.4-8-15.1-5.6-2.7-12-2.8-18.2-3.5a87 87 0 0 1-29.5-8.9c-5.7-2.9-11.9-8.5-9.9-14.6s10.3-6.9 15.3-10.9c9.9-7.9 4-24.2 8.4-36.1 1.9-5 5.6-9.1 7.4-14.2 4.4-12.8-6.7-27.1-20-29.7-9.4-1.8-20.6.3-27.4-6.5-8.8-8.8-4.5-28-16.2-32.2-3-1.1-6.2-.7-9.3-.3a376.8 376.8 0 0 0-66.4 14.7c-4 1.3-8.4 2.6-12.2 1-3-1.3-5.1-4.1-6.8-7a65.1 65.1 0 0 1-8.8-27.1c-.6-6.2-.3-12.6-2.1-18.5a27.1 27.1 0 0 0-25.4-18.5c-3.9 0-8 1-10.7 3.8a20.3 20.3 0 0 0-4.5 9.6 788.6 788.6 0 0 1-18.1 55.8c-4.5 12-11 25.5-23.5 28.2-11.2 2.4-22.4-5.6-28.1-15.5-5.7-10-7.3-21.6-10-32.8-2.2-9.2-5.2-18.2-8.9-26.9-.9-2.1-1.9-4.2-3.8-5.4-1.6-1-3.6-1.2-5.5-1.2-9.4-.3-19.5 1.5-26.2 8a28.9 28.9 0 0 0-7.6 23.6c.9 8.5 4.8 16.4 9.7 23.4 10.4 14.9 25.1 26.2 37.2 39.8 24.7 27.6 38.3 64.1 64.9 89.7 12.6 10.4 26.6 20.7 42.6 19.8z"
      fill="#d1d9ae"
    />
    <path fill="#fff9e7" d="m972.1 814.3 1.8.1L1064 761h-3.9z" />
    <path
      fill="#fff9e7"
      d="m839 761-1 50 134.1 3.3 88-53.3zM873 571h87v22h-87z"
    />
    <path
      fill="#fff9e7"
      d="M955 549h59v61h-59zM1216 547h37v118h-37zM1146 235h299v60h-299zM1106 298.1l40 .9v-64l-40 6.5z"
    />
    <path
      d="M1654.9 372.7c-6.3-4.2-13.9-6.9-18.7-12.7a8.9 8.9 0 0 1-2.2-4.7c-.2-5 6.1-7.4 10.5-10.1 10.5-6.5 12.9-20.8 9-32.1-3.9-11.3-12.6-20.4-20.9-29.3-11.2-12-22-24.5-30.5-38.4-9.9-16.3-16.6-34.7-29.4-49.1-17.1-19.1-44-29.5-57.4-51.2-1.8-2.8-3.3-5.9-5.9-8.1s-15.8 38.9-20.1 59.2c-1.7 8-3.2 16.1-1.8 24.1 1.4 7.7 5.4 14.7 8 22.1 5.2 14.9 4.5 31.6 11.7 45.7 1.4 2.8 3.2 5.5 4.2 8.5 2.1 5.8 1.4 12 .9 18.1a588.3 588.3 0 0 0-2.3 49.7c-.1 28 2.2 57.3 17.9 80.9 1.7 2.5 3.6 5 6.4 6.3 2.1.9 4.4 1.1 6.7 1 12.9-.3 24.8-6.5 36.1-12.6l56.2-30.2 20.6-11c3.6-1.9 7.4-4 9.2-7.6 3.4-6.4-1.9-14.2-8.2-18.5z"
      fill="#c9d3b6"
    />
    <path
      d="m1610.4 418.8-.5-1.4.5 1.4zM1640 266.1c-6.7-6-12.9-1.9-17.8 1.9-4.1 3.2-8.6 6.1-14 6.2-5.4.1-12.1-3-17-9.8a66 66 0 0 1-9.2-25.2l-2.6-12.4c-1.5-7.2-3-14.5-3.6-21.5-.2-2.2-.3-4.3-.9-6.6-.6-2.2-1.7-4.3-2.8-6.4-4.7-8.5-11.4-16.4-17.9-17.9s-11.3 6.3-7.7 15.3c.9 2.3 2.3 4.6 2.8 7 1.3 5.9-3.4 7.8-7.3 8.1-5.3.4-11.1.7-16.9-3.8-3.7-2.8-7-7.3-10.1-11.7-1-1.4-2.1-2.8-3.2-3.2-.9-.3-1.6.1-2.3.5-6.6 4.2-10.9 12.3-15 20.2l-3.7 7.2c-3.7 7.1-7.2 16.7-2.4 27.3 4.6 10.1 13.7 14.3 21.2 17s16.8 7.6 20.9 17.9c.3.8.6 1.7.5 2.4-.1.7-.5 1-1 1.3-5.2 3.1-12.6-.4-19.5-2.9s-14.5-3.5-17.3 3c-1.8 4.3-1 10.9 1.1 17.1 2.1 6.1 5.3 12 8.5 17.6a99 99 0 0 0 10.6 16.5c8.3 9.9 18.3 13.8 27.3 21.6 8.2 7.2 15.4 17.5 23.5 24.9 7.9 7.2 16.4 11.2 24.6 16.8s16.9 13.6 21.8 24.7l-.2-.6-.5-1.4.5 1.4a7 7 0 0 0 3.3 3.1c1.6.5 2.9 0 4.2-.6a12 12 0 0 0 5.7-4c4.2-6.4.1-19.4-1.4-30.1-.9-6.3-.8-12.3-1.2-18.4-.6-12.8-2.8-26.3-6.5-39.9-1.1-4.1-3.3-9.3-6.2-10.1-1.2-.3-2.1.3-3.1.7-12.4 6.3-30.4-5.1-45.9-17.8-2.4-2-5-4.1-7-7.1s-3.3-7.1-2.5-9.7c.9-3.1 4.1-3 6.9-2.5 21.7 3.7 44.6 14.9 67 24 7 2.8 14.3 5.4 19.8 2.9 8.8-4.1 9.6-22.6 1.4-36.6a21.8 21.8 0 0 0-4.9-6.4z"
      fill="#e2e6cf"
    />
    <path
      d="M1631.4 270c-5.9-5.2-11.3-1.7-15.6 1.7-3.6 2.8-7.5 5.4-12.3 5.5-4.8.1-10.6-2.7-14.9-8.6a57.6 57.6 0 0 1-8.1-22.2l-2.3-10.9c-1.3-6.4-2.7-12.8-3.2-18.9-.2-1.9-.2-3.8-.8-5.8-.5-1.9-1.5-3.8-2.5-5.6-4.1-7.4-10-14.4-15.8-15.7-5.7-1.3-9.9 5.5-6.8 13.4.8 2.1 2 4 2.5 6.1 1.1 5.2-3 6.8-6.4 7.1-4.7.4-9.8.6-14.9-3.3-3.3-2.5-6.1-6.4-8.9-10.2-.8-1.2-1.8-2.5-2.8-2.8-.8-.3-1.4.1-2 .4a44.5 44.5 0 0 0-13.2 17.8l-3.3 6.3c-3.2 6.2-6.4 14.7-2.2 24 4 8.9 12 12.5 18.7 15 6.6 2.4 14.8 6.6 18.3 15.7.3.7.5 1.5.4 2.1-.1.6-.5.9-.8 1.1-4.5 2.7-11.1-.4-17.1-2.5s-12.7-3.1-15.2 2.6c-1.6 3.8-.9 9.6 1 15 1.8 5.4 4.7 10.5 7.5 15.5a85.5 85.5 0 0 0 9.3 14.5c7.3 8.7 16.1 12.1 24 19 7.2 6.3 13.5 15.4 20.7 21.9 7 6.3 14.4 9.9 21.6 14.8s14.8 12 19.2 21.7l-.2-.5-.5-1.2.5 1.2a5.7 5.7 0 0 0 2.9 2.7c1.4.4 2.5 0 3.7-.5 1.9-.8 3.8-1.6 5-3.5 3.7-5.6.1-17.1-1.3-26.5-.8-5.6-.8-10.8-1-16.2-.6-11.3-2.5-23.1-5.7-35-1-3.6-2.9-8.2-5.4-8.9-1-.3-1.9.2-2.7.6-10.9 5.5-26.7-4.5-40.4-15.6-2.2-1.8-4.4-3.6-6.1-6.3-1.8-2.6-2.9-6.2-2.2-8.5.8-2.7 3.6-2.6 6.1-2.2 19.1 3.2 39.2 13.1 58.9 21.1 6.1 2.5 12.6 4.8 17.4 2.5 7.8-3.6 8.4-19.9 1.3-32.2a25.4 25.4 0 0 0-4.4-5.7z"
      fill="#d1d9ae"
    />
    <path
      d="M564.1 359.2c-3.2-2-7.4-1.8-11.2-1.4-2.5.2-5 .5-7.2 1.5a8 8 0 0 0-4.7 5.4 10 10 0 0 0 .3 4.2 409 409 0 0 1 2 10.8l.9-.7c0 4.7 2.5 9.4 6.4 12a9.7 9.7 0 0 0 5.4 1.8c3.3-.1 6-2.6 8-5.2a25.4 25.4 0 0 0 5.1-20.5c-.7-3.1-2.3-6.2-5-7.9z"
      fill="#fff9e7"
    />
    <path
      d="m559 552.3.2-1.6c-.2.5-.3 1.1-.2 1.6zM768.3 541.3c.8 2.6 3 5.6 5.5 4.8l1.5-1c2.5-7.9 2.5-16.4 2.5-24.7.3-103.6-1.3-207.2-4.9-310.7 0-1.4-.2-2.9-1.1-3.9-1.5-1.6-4.3-1-5.8.7s-1.8 3.9-2.1 6.1l-6 40.9a73.7 73.7 0 0 0-1.2 16.2c.4 6.6 2.5 13 3.6 19.5 4.7 25.4-3.8 51.3-3.1 77.1.2 8.5 1.4 16.9 3.6 25 2 7.4 4.7 14.6 5 22.2.5 13.1-6.4 25.4-7.1 38.4-.5 11 3.4 21.7 5 32.7 2.8 18.8-1.4 38.6 4.6 56.7zM704.1 368.7c4 2 9.1 2.4 12.9 0 3.3-2.1 5-6 6.4-9.6 1.2-3.4 2.3-7 2.1-10.6s-2.1-7.3-5.4-8.9c-1.4-.6-2.9-.9-4.4-1-3.9-.3-7.8 0-11.6.9-2.4.6-4.9 1.5-6.3 3.6-2.7 3.7 1.8 23.4 6.3 25.6z"
      fill="#e2e6cf"
    />
    <path
      d="M705.5 365.7c3.2 1.5 7.2 1.9 10.2 0 2.6-1.7 4-4.7 5.1-7.7 1-2.7 1.9-5.5 1.7-8.4-.2-2.9-1.7-5.8-4.3-7-1.1-.5-2.3-.7-3.5-.8-3.1-.3-6.2 0-9.2.7-1.9.5-3.9 1.2-5 2.8-2.2 3.1 1.5 18.7 5 20.4z"
      fill="#fff"
    />
    <path
      d="M706.8 363c2.5 1.2 5.5 1.5 7.8 0 2-1.3 3.1-3.6 3.9-5.9a16 16 0 0 0 1.3-6.4c-.2-2.2-1.3-4.5-3.3-5.4-.8-.4-1.8-.5-2.7-.6-2.3-.2-4.7 0-7 .5-1.5.4-3 .9-3.8 2.2-1.7 2.4 1.1 14.3 3.8 15.6z"
      fill="#e2e6cf"
    />
    <path
      d="M687.9 371.8c1.2 1.9 1.7 4.6 3.8 5.5 1 .5 2.2.3 3.4.2l11.6-1.3c.6-.1 1.1-.1 1.6-.4.5-.3.9-.9 1.3-1.3 1.2-1.5 2.7-2.5 3.9-3.9 2.6-2.9 3.7-7 3-10.7a7.1 7.1 0 0 0-1.3-3.1c-1.3-1.7-3.7-2.3-5.9-2-2.1.3-4.1 1.4-5.9 2.6s-3.6 2.5-5.6 3.3c-2.2.9-4.6 1.2-6.8 2-2.2.9-4.3 2.6-4.6 5 0-.1.7 2.8 1.5 4.1z"
      fill="#c4afd9"
    />
    <path d="M645.6 333.3c0 .4.2.7.4 1h.3l-.7-1z" fill="#ffe0cc" />
    <path
      d="m519.5 429.5-.7-.9c-.5-.3-.9-.6-1.5-.8l2.2 1.7zM501.1 462.4l.3-1.4-.3 1.4z"
      fill="#fff9e7"
    />
    <path
      d="m552.2 344.2 4-.8c-1.4-.3-2.8 0-4 .8zM551.9 344.2h.2-.2z"
      fill="#c4afd9"
    />
    <path
      d="M629.4 460.3c-4.7-.1-9.4.8-13.8 2.6-2.7 1.1-5.5 2.8-6.5 5.5-.5 1.3-.5 2.7-.6 4l-.3 9.6c-.1 2.3-.2 4.7.6 6.9 1.6 4.6 6.5 7.2 11.2 8.3l.1.5 8-20.6c2-5.1 4-10.7 2.6-16l-.4-.7-.9-.1zM1515.4 324.1l.3-1.4a4 4 0 0 0-.3 1.4z"
      fill="#fff9e7"
    />
    <path
      d="M1569.8 328.4c-4.3-1-8.8-.8-13.2-.1-3.7.5-7.4 1.3-11 .5-3.2-.8-6.1-2.8-8.6-4.9s-5-4.4-8-6-6.5-2.3-9.6-1.1c-3.1 1.2-5.3 4.9-4.2 8l.2-.7.3-1.4-.3 1.4c-.4 2.8.6 5.7 2 8.2 1.6 2.9 3.8 5.6 5.2 8.6 1.3 2.9 1.9 6.2 3.6 8.9 1.6 2.6 4.2 4.4 6.2 6.7 2.2 2.6 3.7 5.8 5.9 8.6 2 2.5 4.4 4.6 6.9 6.7 1.8 1.5 3.9 3.2 6.3 3.3 2.7.1 5.1-1.7 7-3.7 2.3-2.3 4.3-5.1 4.8-8.3.7-4.9-2.4-10.4.5-14.4 1.4-2 4-2.9 6.3-3.8 3.2-1.3 6.3-2.9 9.1-4.8.6-.4 1.2-.8 1.4-1.4.4-.9.1-1.9-.4-2.8-2-3.8-6.1-6.4-10.4-7.5z"
      fill="#fff9e7"
    />
    <path
      d="M1569.2 324.6a35 35 0 0 0-12.9-.1c-2.2.3-4.5.7-6.8.6-2.2-.1-4.1-.8-6-1.9-3.4-2.1-6.1-5.1-9.4-7.2-3.2-2.1-7.4-3.4-11.2-2.1-3.6 1.3-6.3 5.3-5.1 9.2.4 1.3 2.6 1.5 2.9 0l.4-1.9-2.9-.8c-.8 3.9.2 7.5 2.3 10.8 1.2 1.9 2.5 3.7 3.6 5.7 1.1 2.1 1.6 4.4 2.5 6.5.8 2 2 3.8 3.5 5.4 1.5 1.6 3.2 3 4.5 4.8 1.3 1.9 2.4 3.9 3.8 5.7 1.3 1.8 2.8 3.4 4.5 4.9 3 2.7 6.7 6.4 11.1 5.4 3.8-.9 7.3-4.8 9-8.2.9-1.8 1.4-3.8 1.3-5.9-.1-2.1-.6-4.1-.7-6.2-.1-1.9.2-3.8 1.8-5 1.6-1.2 3.7-1.8 5.5-2.6 2.4-1.1 4.8-2.3 7.1-3.8 2.1-1.4 2.7-3.3 1.6-5.7-2-3.9-6.2-6.5-10.4-7.6-1.9-.5-2.7 2.4-.8 2.9 3.3.9 6.6 2.7 8.3 5.9.4.8.7 1.4-.1 2a41.9 41.9 0 0 1-8.4 4.4c-3.2 1.3-6.5 2.8-7.3 6.5-.8 3.6.8 7.1.5 10.7-.3 3.5-3.3 7.1-6.2 9a4.7 4.7 0 0 1-5.1.3c-1.7-1-3.2-2.4-4.7-3.7a27.8 27.8 0 0 1-4.1-4.3c-1.2-1.6-2.2-3.4-3.3-5a31.6 31.6 0 0 0-3.7-4.5c-1.4-1.4-2.9-2.7-3.9-4.4-1.2-2-1.6-4.2-2.5-6.3a27 27 0 0 0-3.3-6c-2.2-3.3-4.3-6.6-3.4-10.7.4-1.9-2.4-2.7-2.9-.8l-.4 1.9h2.9c-1-3.1 2-5.8 5-5.9 3.6-.2 6.8 1.9 9.5 4.1 2.7 2.2 5.3 4.8 8.6 6.2 3.6 1.6 7.3 1.5 11.1.9 4.5-.6 9-1.3 13.5-.3 1.7.4 2.5-2.4.7-2.9z"
      fill="#e5e289"
    />
    <path
      d="M1555.2 341.2c-1.3-1.5-3.4-1.8-5.4-2-2.9-.2-10.1 4.1-10.2 5.6-.2 2.3-.2 4.8 1.2 6.6a14.2 14.2 0 0 0 7.9 4.3c2.1.3 4.4-.2 5.9-1.8 1.8-1.9 1.9-4.9 1.9-7.6 0-1.7-.1-3.7-1.3-5.1z"
      fill="#ffe0cc"
    />
    <path
      d="m1626.3 319.1-1.5-.3-18-1.5c-1.8-.1-3.9-.1-4.8 1.4-.4.7-.4 1.6-.8 2.5a8 8 0 0 1-2.7 3.1l-13.1 10.4c-3.1 2.5-6.6 5.5-6.6 9.5 0 4.5 4.1 7.7 6.5 11.5 1.8 2.9 2.6 6.4 3.9 9.6 1.3 3.2 3.4 6.4 6.7 7.5.9.3 1.9.5 2.5 1.3.3.5.4 1.2.5 1.8.2 2.4 9.4-2.3 12.7-7.5a101 101 0 0 0 3.8-6.5c2.9-5.3 5-10.9 7.2-16.5l4.5-11.7c1.7-4.4 3.3-9.8.4-13.5-.2-.5-.7-.9-1.2-1.1z"
      fill="#d1d9ae"
    />
    <path
      d="M1640.7 324.2c-.4-.2-.8-.2-1.3-.2l-15.1-1.2c-1.5-.1-3.3-.1-4 1.2-.4.6-.4 1.4-.6 2.1a6.2 6.2 0 0 1-2.2 2.6l-10.9 8.7c-2.6 2.1-5.5 4.6-5.5 8 0 3.8 3.5 6.4 5.5 9.6 1.5 2.5 2.2 5.3 3.3 8 1.1 2.7 2.8 5.3 5.6 6.3.8.3 1.6.5 2.1 1.1.3.4.4 1 .4 1.5l.6 6.1 1.8.7 8.2-13.2 3.2-5.4c2.4-4.4 4.2-9.1 6-13.8l3.8-9.8c1.4-3.7 2.8-8.2.3-11.4-.4-.4-.7-.7-1.2-.9z"
      fill="#e2e6cf"
    />
    <path
      d="M1633.7 322.2c-1.3-.4-2.8-.4-4.2-.5l-4.8-.4-4.6-.4c-1.2-.1-2.4-.2-3.5.1-1.1.3-1.9.9-2.4 2l-.5 1.6c-.2.7-.8 1.1-1.3 1.5-2.3 2-4.8 3.8-7.2 5.7-3.6 2.9-8.8 6.2-7.8 11.6.5 2.4 2.2 4.2 3.6 6 1.7 2.1 2.5 4.4 3.4 6.9.9 2.6 2.2 5.2 4.4 6.9l1.8 1c.7.3 1 .2 1.2.9.2.7.2 1.7.2 2.4l.3 2.9c.1.7.4 1.2 1.1 1.5l1.6.6c.6.2 1.4-.2 1.7-.7l8.1-13c2.5-4 4.4-8.3 6.1-12.7 1.7-4.4 3.6-8.7 5.1-13.2 1.1-3.3 1.7-8.5-2.1-10.6-1.7-.9-3.2 1.7-1.5 2.6 1.5.8 1.5 3 1.3 4.5-.2 1.9-1 3.7-1.7 5.4l-4.7 12.2c-3.4 8.3-8.5 15.6-13.2 23.2l1.7-.7-1.6-.6 1.1 1.5-.4-4.4c-.1-1.1-.1-2.4-.9-3.3-.7-.8-1.7-1-2.7-1.4a6.7 6.7 0 0 1-2.6-2.4c-1.3-2-1.9-4.4-2.8-6.6-.9-2.2-2.2-4-3.7-5.9-1.2-1.5-2.6-3.4-2-5.5.6-2.1 2.6-3.6 4.2-4.9l6.8-5.5c1.8-1.5 4.3-2.9 5.1-5.2.2-.5.1-1.1.6-1.4.4-.3 1.1-.2 1.5-.2 1.5 0 3.1.2 4.6.4l4.8.4c1.5.1 3.4 0 4.8.5 2.1.7 2.9-2.2 1.1-2.8z"
      fill="#e5e289"
    />
    <path
      d="M1565.3 427c-.8-1.6-2.2-2.8-3.6-4-4.7-4.1-9.5-8.3-15.5-10-4.5-1.2-9.4-.9-13.7 1a13 13 0 0 0-4.1 2.8c-1.3 1.5-1.9 3.5-2.5 5.5a91 91 0 0 0 3 26.8c.5 1.4 1 2.8 2 3.9a11 11 0 0 0 4.6 2.6 22 22 0 0 0 11.5 2.1c3-.5 5.7-2.2 8.2-4 4.3-2.9 8.9-6 10.7-10.9 1.3-3.5 1.1-7.3.6-11-.1-1.5-.4-3.2-1.2-4.8z"
      fill="#c4afd9"
    />
    <path
      d="M1629.9 337.8c-.4-.3-.9-.3-1.3-.4-4.5-.4-9.2 1.7-12 5.2-.3.5-.7.9-.8 1.5-.2.6-.2 1.3 0 2a7.3 7.3 0 0 0 2.7 4.4c1 .8 10.4-.2 11.8-3 1.1-2.2.9-4.7.7-7.1-.2-1-.3-2.1-1.1-2.6z"
      fill="#b2c075"
    />
    <path
      d="m938.2 158.3-78.2 2.9c-7.6.3-24.4 41.4-20.1 58.3 4.3 16.9 17.6 32.3 34.8 34.9 12.5 1.9 25-2.8 37.6-2.2 7.8.4 15.3 2.8 23 3.3 3.4.2 7.2-.1 9.3-2.8 1.1-1.3 1.5-3.1 1.9-4.7 6-24.3 9-49.4 8.9-74.5 0-4-.2-8.4-2.9-11.4-3.3-3.9-9.2-4-14.3-3.8z"
      fill="#c9d3b6"
    />
    <path
      d="m1155.4 133-81.8.3c-12 0-24 .1-35.9.9-9.5.6-19 1.8-28.6 1.6-10.2-.2-20.3-2-30.5-3-13.4-1.3-26.9-1.1-40.4-.9-12 .1-24 .3-35.9 1.6-14.4 1.6-29.2 4.8-43 .8-6.1-1.7-11.8-4.8-18-6-11.5-2.1-38.8 13.9-36 17.1 2.7 3.2 7.2 4.5 11.5 5.1 28 4 57.1-11.7 84-3.6 10 3 20.1 9.3 30.1 6.4 3.6-1.1 6.7-3.2 10.2-4.6 9.2-3.7 22-.1 25 9 1.8 5.3.1 11-1.5 16.3s-3 11.2-.7 16.3c2.3 5.1 9.8 8.3 14.1 4.5 1.7-1.5 2.5-3.8 3.2-5.9 3-10.2 4.3-20.8 3.7-31.4-.1-1.5-.2-3.1.7-4.4 1.1-1.5 3.2-2 5.2-2.2 17-1.9 34 2.2 51 3.5 16.8 1.3 33.6-.1 50.4-1.4l25.4-2.1 65.6-5.4c.9-.1 2-.2 2.6-.9 1-1.2 0-2.9-1.1-4-7.3-7.2-18.9-7.6-29.3-7.6zM1382.2 127.8c-59.5-2.2-177.7.4-177.7.4-6.4.3-8.5 9.9-4.4 14.7s11.3 5.7 17.6 5.5c12.2-.5 24.2-3.7 36.4-4.6 12.3-.9 24.7.5 37 1.5 30.1 2.5 60.4 2.7 90.5.6 3.4-.2 6.9-.5 9.9-2.1s5.4-4.8 5-8.2c-.8-6-8.4-7.6-14.3-7.8z"
      fill="#c9d3b6"
    />
    <path
      d="M1165.7 161.8a450.7 450.7 0 0 0-86.9 1.8c-9.1 1.1-18.2 2.5-27.3 2.9a138 138 0 0 1-40.5-3.9l-.8 3c-7.3 9.5-7.2 22.8-5 34.6s6.2 23.4 5.9 35.4c-.1 3.3-.4 7 1.5 9.6 2.2 2.9 6.2 3.4 9.8 3.7 17.4 1.3 34.8 1.4 52.2.5 2.8-.1 5.8-.4 8.2-1.9 2.3-1.5 3.7-3.9 4.7-6.4 6.1-14.9 1.5-34.9 13.8-45.5 10.3-8.9 25.9-5.1 39.4-3 13.1 2 47.1-17.6 42-24.4-3.9-4.9-10.8-5.9-17-6.4zM1399.2 168.6c-10.1-8-23.9-9.1-36.8-9-13.6.1-27.2 1.2-40.7 2.6-12.1 1.3-24.2 2.9-36.4 2.9-9.7 0-19.3-1.1-29-1.6-17.6-1-65.3 13.6-63.9 22.6s9.4 15.8 18.1 18.3 18 1.6 26.9.1c27.5-4.6 55-14.2 82.7-10.7 22.2 2.8 43 14 65.3 13.8 6.3-.1 12.9-1.2 17.7-5.3 9.9-8.5 6.3-25.7-3.9-33.7z"
      fill="#c9d3b6"
    />
    <path fill="#fff9e7" d="M913 588h49v8h-49z" />
    <path
      d="m1019.6 728.3.3-30.8c0-5.8 0-12-2.9-17-5.1-8.8-16.6-10.8-26.6-11.2-11.7-.5-23.4 0-35.1 1.5-7.2.9-14.5 2.1-21.7 1.5-6.7-.6-13.2-2.8-19.9-3.9-18.4-3.1-37 2.1-55.5 4.8a201.6 201.6 0 0 1-76.6-3.7c-2.1-.5-4.3-1.1-5.9-2.7a11.5 11.5 0 0 1-2.6-5.7c-6.5-26.2-4.2-54-10.5-80.2-.5-2.2-1.2-4.7-3.1-6.1-1.7-1.4-4.1-1.5-6.3-1.6l-41.3-1.9c-14.5-.7-29.1-1.4-43.7-.3-12 .9-24 3-36 3.3-15.3.5-30.5-1.8-45.8-1.9-1.8 0-3.7 0-5.3 1-5.5 3.3-1.5 11.8 3 16.5l.2 2.5c6.8 4.4 7.6 14.1 6.8 22.2s-2.5 16.9 1.5 24c7.7 13.8 29.5 10.6 40.7 21.6 7.2 7.1 8.3 18.2 12.3 27.6a88.5 88.5 0 0 0 20.8 26.8l18.3 18.3 4.5 4.3h329.3c1-3 1.1-6 1.1-8.9z"
      fill="#c9d3b6"
    />
    <path
      d="M740.5 584.9c-1.8-.2-3.7 0-5.3-.8-1.7-.8-2.7-2.6-3.5-4.2-4.8-9.1-9.8-18.4-11.1-28.6-.4-3.2-.5-6.5-1-9.7-2-10.8-10.1-19.3-17.8-27.2-3.4-3.5-7-7.1-11.6-8.8-3.5-1.3-7.4-1.3-11.1-1.4l-24-.2c-3 0-6.2 0-9 1.1-5.7 2.4-8.3 8.7-10.5 14.5L618.9 565l.1.4c5.7 9.6 19 11 28.1 17.5 3.5 2.5 6.5 5.9 10.4 7.6 1.6.7 3.4 1 5 1.8 2.1 1 3.8 2.6 5.5 4.2l27 25.7c2.4 2.2 4.7 4.5 7.6 6.2 7.7 4.5 17.3 3.5 26.2 2.5 3-.4 6.1-.8 8.8-2.3 2.9-1.7 4.9-4.5 6.8-7.2l8.2-11.6a11 11 0 0 0 2.4-5c.2-1.8-.5-3.6-1.2-5.3-2.7-6.4-6.5-13.7-13.3-14.6z"
      fill="#e2e6cf"
    />
    <path d="m661.6 523.9-.4 1.2v.2l.4-1.4z" fill="#c4afd9" />
    <path
      d="M663.5 532.2c1.9 2.3 4.3 4.2 5.9 6.7 1.2 2 1.7 4.4 3.1 6.3 2.6 3.7 7.6 4.8 12.1 5.4 4 .5 8.1.9 12.2 1 2 .1 4 .1 5.7-.9 2.5-1.4 3.5-4.4 4-7.2.6-2.8.8-5.8-.2-8.5-1.5-4.1-5.7-6.6-8.5-10-2.1-2.6-3.5-5.8-6.2-7.9a18.7 18.7 0 0 0-7.6-3 47.7 47.7 0 0 0-19.8-2c-1.5.3-3.3.9-3.8 2.4-.2.6-.2 1.3-.1 2l.8 8.5.4-1.2-.4 1.4v-.2c-.4 2.5.7 5.2 2.4 7.2z"
      fill="#c4afd9"
    />
    <path
      d="M660.9 516.4zM692.2 519.2c-.7-2.8-3.9-4.1-6.7-4.9-5.2-1.5-10.6-2.5-16-3.2-2.3-.3-4.7-.4-6.7.7a7 7 0 0 0-2.9 3.6l.2 1.6-.2-1.6a9.7 9.7 0 0 0-.7 3.7c0 1.1.2 2.1.4 3.2-.2 1.8-.1 3.6.8 5.2 1.2 2.1 3.5 3.3 5.5 4.6 1.7 1.2 3.3 2.6 4.6 4.3 1 1.2 1.8 2.6 3.1 3.5 1.2 1 3 1.5 4.4.9 1.5-.7 2.2-2.5 2.9-4.1s1.8-3.3 3.5-3.3c1.5 0 3.3 1.2 4.3.1l.5-1 2.7-8.6c.3-1.5.7-3.1.3-4.7z"
      fill="#ffe0cc"
    />
    <path
      d="M670.4 645.8c-10.8-7.9-26.3-8.1-35.6-17.8-6.1-6.3-8.1-15.5-13.1-22.7a59.3 59.3 0 0 0-12-12c-4.4-3.7-9.1-7.6-14.8-8-5.7-.5-12.1 4.3-11 10l.4.6c4 3.6 5.1 9.3 7.5 14a53 53 0 0 0 6.8 9.5l25.4 30.7c2.5 3 5 6 7.9 8.7 3.3 3.1 7.1 5.7 10.3 8.9 9 9.1 12.6 22.3 20.2 32.7 3.1 4.2 7.8 8.2 12.8 7.2 3.8-.8 6.5-4.2 8.5-7.4 4.3-6.9 7.6-15.2 5.8-23.1a38 38 0 0 0-2.8-7.3c-4.1-9-8.5-18.2-16.3-24z"
      fill="#e2e6cf"
    />
    <path
      d="M658 525.9c.1 1.1.4 2.3 1.3 3 .6.4 1.4.6 2.1.7 3.5.5 7.2.8 10.5-.3 3.4-1.1 6.4-4 6.6-7.5.1-1.8-.5-3.5-.8-5.3-.2-1.9-.2-4.2-1.9-5.1-.6-.4-1.3-.5-1.9-.5a37 37 0 0 0-11.5.4c-1.3.3-2.7.6-3.6 1.6-1.5 1.5-1.4 3.9-1.2 6l.4 7z"
      fill="#b2c075"
    />
    <path
      d="M685.1 595.2c5.8 7.3 6.1 18 12.8 24.5 1.9 1.8 4.2 3.2 6.7 4.2 3.7 1.6 7.6 2.6 11.6 2.8 2 .1 4.2.1 6-1 3.2-2 3.8-6.4 3.9-10.2l.6-13.2c.1-2.8.2-5.8-1.3-8.2a13.8 13.8 0 0 0-6.1-4.5c-10.3-5-21.2-10-32.5-9.2-3.4.2-7.6 1.8-7.9 5.3-.1-.1 3.8 6.4 6.2 9.5z"
      fill="#fff0e6"
    />
    <path
      d="M708.2 616.2a8.5 8.5 0 0 0 4.4 5.4c1.2.6 2.5.9 3.9 1.2 1.3.3 2.8.5 3.8-.3.8-.6 1.1-1.6 1.4-2.5.9-3.4 1.3-6.9 1.3-10.4 0-.8 0-1.6-.4-2.3-.7-1.4-2.5-1.8-4-1.9-3.6-.2-11 8.5-10.4 10.8z"
      fill="#ffe0cc"
    />
    <path
      d="M738.5 608.7c-.5.9-.5 2-.4 3 .2 5 1 9.9 2.3 14.7l.1 2.1c2.4-7.4 10-12.3 12.2-19.8 1.4-4.8.2-10.2-3-14-1.2-1.4-2.7-2.7-3.2-4.4-.1-.4-.2-.8-.5-1.1-.8-.7-2 .2-2.4 1.1-1.7 3.3-.5 7.3-.3 11 .1 1.4-.1 2.9-.9 4-1.2 1.4-3.1 2-3.9 3.4zM680.9 581.3c.1-.4 0-.9-.2-1.2-1.1-1.9-3.7-1.9-5.8-1.7-9.1.9-18.5 2-26.2 6.9v.5c2.6 2.4 5.5 4.4 8.7 5.9 1.2.6 2.5 1.1 3.6 1.8 1.5 1 2.8 2.5 4 3.8 5.8 6.5 12.3 12.3 19.5 17.2 3.5 2.3 7.2 4.6 9.3 8.2 1.3 2.3 2.7 5.4 5.3 5.2a61.8 61.8 0 0 0-8.3-11.9c-1.2-1.4-2.5-2.7-3.5-4.3-2.5-4.2-2.2-9.4-4.1-13.8-1.1-2.6-2.9-4.8-4-7.4s-1.2-5.9.7-7.9c.5-.5.9-.8 1-1.3zM621.1 551.8c2.2.7 4.4 1.1 6.7 1.2 1.5.1 3.2-.1 4.1-1.3a77 77 0 0 0 1.9-14.5c0-1.4 0-2.9-.8-4.1a3.8 3.8 0 0 0-3.5-1.8 2 2 0 0 0-1.6.7c-.4.6-.3 1.4-.3 2.1.1 6-6.7 10.2-6.9 16.2l.4 1.5z"
      fill="#d1d9ae"
    />
    <path
      d="M640.7 526.7c2-.5 3.7-2.2 4.6-4.1.9-1.9 1.2-4 1.3-6.1V512c0-1.2-.2-2.4-.7-3.5s-1.6-1.9-2.7-2c-1.2 0-2.2.8-3 1.6-3.5 3.8-4.6 9.1-7.2 13.5-1.1 1.9-2.4 3.7-3.4 5.6s3 10.1 5 9.3c1.5-.6 1.7-2.6 1.5-4.2-.2-1.6-.4-3.5.8-4.6 1.1-.7 2.6-.7 3.8-1zM621 600.4c-6.7-4.3-17.1-15.3-17.1-15.3-1-.3-1.9.7-2.3 1.7-1.3 3.1-.9 6.8.4 9.9s3.5 5.8 5.7 8.4c5.6 6.3 20.3 6 18.5 1.2a11 11 0 0 0-2-3.5c-.9-1.1-2.1-1.7-3.2-2.4z"
      fill="#fff9e7"
    />
    <path
      d="M243.6 157.7a39.9 39.9 0 0 0 27.2 5.9c4.4-.9 8.5-3 12.8-4.3a88.5 88.5 0 0 1 26.2-2.7l101.2-.4c15.6-.1 31.3-.1 46.4-3.8 7.7-1.9 15.3-4.6 23.3-4.7 8.4-.1 16.4 2.9 24.5 4.8 27.6 6.4 56.4 0 84.7-.1 33-.2 66.7 7.9 98.4-1 7.3-2.1 14.4-5 22-5.7 21.6-2 43.3 14.3 63.8 7.4 5.8-2 11.6-7.8 9.2-13.3-2.2-4.9-9-5.6-14.6-5.4l-327.8 7c-57.4 1.2-115 2.4-172.2-2.4-11-.9-25.5.1-28.4 10.4l.6.4c-3.2 1.1-.4 6.1 2.7 7.9z"
      fill="#c9d3b6"
    />
    <path d="m539.4 577.1 2.2 1.6-1.5-1.4-.7-.2z" fill="#d1d3c2" />
    <path
      d="M671.1 755.3c2.7-7.2-9-27.2-11.6-29.7-8.6-8.1-19.2-15-23.4-26-1.7-4.4-2.2-9.2-4.1-13.4-1.8-4-4.8-7.3-7.2-11.1-3.1-4.8-5.2-10.3-7.6-15.5a178.4 178.4 0 0 0-44.5-55.9 367.1 367.1 0 0 0-31-24.9c39.7 37.5 55.7 94.4 92.7 134.7 4.8 5.2 10 10.2 13.8 16.3 5.8 9.4 8 21.3 16.5 28.4.9.8 2.1 1.5 3.3 1.3 1.2-.2 2-1.4 2.5-2.6l.1-.3.5-1.3z"
      fill="#c9d3b6"
    />
    <path fill="#fff9e7" d="M676 766h1.4l-1.4-2z" />
    <path
      d="m243.1 163.2 30.7 47.5a286.1 286.1 0 0 0 23.2 32.5c7.5 8.8 16.1 16.6 23.7 25.3 13.2 15 23.4 32.5 33.8 49.5 13.8 22.4 28.1 44.5 43 66.1 20.4 29.6 41.9 58.4 63.4 87.1l30.6 40.9 22.6 30.3a615.6 615.6 0 0 0 49.1 60.1c6.8-7 3.5-19.1-2.9-26.5s-15.2-12.4-20.7-20.5c-5.6-8.1-7.2-18.5-13-26.5-4.7-6.5-11.8-10.7-17.7-16.1-25.3-23.1-27.1-65.2-53.6-86.8-7.3-6-16.2-10.1-22.6-17.1-10.4-11.5-12.2-28.7-21.1-41.5-10.7-15.3-30.5-23-39-39.6-4.9-9.6-5.3-21.2-11.2-30.3-6-9.3-16.7-14.3-23.9-22.6-10.1-11.6-12.4-28.1-19.9-41.5-8.5-15.3-23.2-25.9-33.7-39.9-6.2-8.3-10.9-17.8-17.6-25.7-6.6-8-23.1-22-23.1-22-6.1 2.1-3.7 11.7-.1 17.3zM980.9 210.8c-5.6-.9-10.6 4.3-12 9.8-1.4 5.5-.3 11.3 0 17 .3 5.1-.1 10.3-1.1 15.4-.4 2.1-1 4.2-2.3 5.8-2.8 3.4-7.9 3.4-12.3 3.9-6.3.7-12.3 2.9-17.6 6.4-4.1 2.8-7.7 6.3-12.2 8.4-7.9 3.6-17.2 2.1-25.3-.9s-15.8-7.3-24.3-9.3a45.7 45.7 0 0 0-24.6 1c-2 .6-4.1 1.4-6.2 1.1-4.7-.7-6.6-6.2-7.5-10.9a239.4 239.4 0 0 1-4.3-35.9c-.1-2.1-1-5-3.1-4.7-1.9.3-2.3 2.8-2.2 4.6l3.3 84.8 1.5.7c33.5 14.7 71.8 11.9 108.3 8.9 11.2-.9 22.4-1.9 33.1-5.3 4.6-1.5 9.3-3.7 11.6-8 1.2-2.3 1.5-5 1.8-7.6 2.4-21.8 4-43.8 4.8-65.7.2-7.9-1.6-18.3-9.4-19.5z"
      fill="#c9d3b6"
    />
    <path
      d="M1371.2 258h-225.5v38h-71.8v5.2a46 46 0 0 0-43-29.2 45.8 45.8 0 0 0-45.2 37H812v243h25.3v19h93v-19h109.2v21h85.9v-21h245.7v-36h73.8V291h-73.8v-33z"
      fill="#e9eadf"
    />
    <path
      d="M794.6 1014.9 161.8 131.8a25 25 0 0 1-2.7-5.1c-.7-1.8-1.1-3.7-1.2-5.6-.1-1.9 0-3.9.3-5.8a22.4 22.4 0 0 1 5.2-10.3c1.3-1.5 2.8-2.7 4.4-3.7a23.2 23.2 0 0 1 11-3.3l1358.3-17.7a27.3 27.3 0 0 1 12.5 2.8 31.4 31.4 0 0 1 10.1 7.9L1776 362.2"
      fill="none"
      stroke="gray"
      stroke-width=".4"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m655.6 71.4 82-1v13.7l-81.8 1-.2-13.7"
    />
    <text
      transform="matrix(.9757 -.01269 .01298 .9999 655.7 82.3)"
      fill="gray"
      font-family="ArialMT"
      font-size="12"
    >
      RUA
    </text>
    <text
      transform="rotate(-.8 6705.5 -52289)"
      fill="gray"
      font-family="ArialMT"
      font-size="12"
    >
      KELLERS
    </text>
    <g fill="gray" font-family="ArialMT" font-size="12">
      <text transform="matrix(.5684 .7932 -.8129 .5825 411.8 522.6)">RUA</text>
      <text transform="matrix(.5826 .8131 -.8129 .5825 426.2 542.7)">
        DESEMBARGADOR
      </text>
      <text transform="rotate(54.4 -372.5 797.9)">ERMELINO</text>
      <text transform="rotate(54.4 -405.5 862.1)">DE</text>
      <text transform="rotate(54.4 -415.5 881.5)">LEÃO</text>
    </g>
    <g fill="gray" font-family="ArialMT" font-size="12">
      <text transform="matrix(.6088 .7626 -.7815 .6238 1582.2 103.9)">RUA</text>
      <text transform="matrix(.6241 .7817 -.7815 .6239 1599.7 125.8)">
        ÉBANO
      </text>
      <text transform="rotate(51.4 646.5 1772)">PEREIRA</text>
    </g>
    <path
      fill="none"
      stroke="#fff9e7"
      stroke-width="9"
      stroke-miterlimit="10"
      d="m1094 745.4 143-28.4-9-76-81-4-77 103h33z"
    />
    <path fill="#e9eadf" d="M1103 735h-.4L788.7 920.9l2.3 3.1z" />
    <path
      fill="#efe8ce"
      d="m1594 1015-313.6-388-185.1 108.8h.4L779.1 926.3l-3.1 4.9 51.8-.8-1 50.3z"
    />
    <path
      fill="none"
      stroke="#eadb9d"
      stroke-miterlimit="10"
      d="M1145.7 233v63.3M1135.7 233v63.3M1125.7 233v63.3M1115.7 233v63.3"
    />
    <g fill="none" stroke="#eadb9d" stroke-miterlimit="10">
      <path
        d="M1093 242.7h53M1093 252.7h53M1093 262.7h53M1093 272.7h53M1093 282.7h53M1093 292.7h53"
      />
    </g>
    <path fill="#fff9e7" d="M1445 291h48v169h-48z" />
    <path
      fill="none"
      stroke="#eadb9d"
      stroke-miterlimit="10"
      d="M955 560h62M955 570h62"
    />
    <g fill="none" stroke="#eadb9d" stroke-miterlimit="10">
      <path d="M955 580h62M955 590h62" />
    </g>
    <g fill="none" stroke="#eadb9d" stroke-miterlimit="10">
      <path d="M872 577h41M872 587h41" />
    </g>
    <path
      fill="none"
      stroke="#e5d985"
      stroke-miterlimit="10"
      d="M955 600h62M955 610h62"
    />
    <path
      fill="none"
      stroke="#eadb9d"
      stroke-miterlimit="10"
      d="M912.6 571v29M902.6 571v29M892.6 571v29M882.6 571v29M872.6 571v29"
    />
    <g fill="none" stroke="#eadb9d" stroke-miterlimit="10">
      <path
        d="M1494 300.6h-49M1494 310.6h-49M1494 320.6h-49M1494 330.6h-49M1494 340.6h-49M1494 350.6h-49M1494 360.6h-49M1494 370.6h-49M1494 380.6h-49M1494 390.6h-49M1494 400.6h-49M1494 410.6h-49"
      />
    </g>
    <path
      d="M857.5 197.4c-2.8-5.5-.6-12.5 3.8-16.8s10.5-6.3 16.6-7.6c3.1-.6 6.6-1.1 9.2.7 1.5 1 2.4 2.5 3.6 3.8 4.9 5.1 13.1 5.5 20 3.5s13.1-5.6 19.9-7.5 15.1-1.4 19.8 3.9c5.8 6.5 3.7 16.6 4.2 25.3.4 6 2.2 11.9 2.3 17.9.1 6-2.2 12.7-7.7 15.3-4.2 2-9.3 1.1-13.7-.7-4.3-1.8-8.3-4.5-12.8-5.9-15-4.9-32.1 4.4-46.9-1.1-14.6-5.4-20.8-23.6-18.5-39"
      fill="#e2e6cf"
    />
    <path
      d="M866.9 198.8c-2.3-4.4-.5-10.1 3.1-13.6s8.5-5.1 13.4-6.1c2.5-.5 5.3-.9 7.4.6 1.2.8 2 2 2.9 3.1 4 4.2 10.6 4.4 16.1 2.9s10.6-4.6 16.1-6.1 12.2-1.1 16 3.2c4.7 5.3 3 13.4 3.4 20.5.3 4.9 1.8 9.6 1.9 14.5 0 4.9-1.8 10.3-6.2 12.4-3.4 1.6-7.5.9-11.1-.6s-6.7-3.6-10.3-4.8c-12.1-3.9-26 3.6-37.9-.9-11.8-4.4-16.8-19.1-15-31.5"
      fill="#e5e289"
    />
    <path
      d="M1015.3 179.6a16.7 16.7 0 0 0-10.1 9.4c-2 4.3-2.6 9.1-2.8 13.9-.1 1.3-.1 2.6.5 3.7a7.4 7.4 0 0 0 3.1 2.4c12 5.3 26.2 3.8 38.4 8.8 6 2.5 11.3 6.4 17.5 8.5 4.3 1.4 8.8 1.9 13.3 2.3 5.5.6 11.7.9 16-2.6 4.4-3.7 5.2-10.1 5.5-15.9l1.3-20.2c4.6 5.1 11.8 6.7 18.5 7.9 4.9.9 9.9 1.9 14.9 1.2s9.9-3.1 12.3-7.6c3.1-5.8.6-13.5-4.3-17.9-5-4.4-11.8-5.9-18.4-6.3-11.2-.6-22.4 2.1-33.7 2.8-13.3.9-26.8-.8-39.4-5-3.9-1.3-8.3-2.9-12.2-1.3"
      fill="#e2e6cf"
    />
    <path
      d="M1039.1 187.6c-3.2.9-5.7 3.6-7.1 6.6-1.4 3-1.8 6.4-2 9.8-.1.9-.1 1.8.4 2.6a4 4 0 0 0 2.2 1.6c8.5 3.7 18.4 2.7 27 6.2 4.2 1.7 8 4.5 12.3 6 3 1 6.2 1.3 9.3 1.6 3.9.4 8.2.6 11.2-1.9 3.1-2.6 3.6-7.1 3.9-11.1.3-4.7 9.2-9.5 13.9-8.6 3.5.7 7 1.3 10.5.9s7-2.2 8.7-5.3c2.2-4.1.4-9.5-3.1-12.6s-8.3-4.2-13-4.4c-7.9-.4-15.8 1.4-23.7 2-9.3.6-18.8-.6-27.7-3.5-2.8-.9-5.8-2-8.6-.9M835.7 250.2c.5-2.9 3.4-5.1 6.3-4.9s5.5 2.8 5.6 5.7c.1 1.2-.2 2.5-.2 3.7.2 4.5 4.8 7.5 9.1 8.7 4.3 1.2 9.2 1.8 12.5 4.8 3.7 3.4 4.5 9 7.5 13 3.6 4.7 9.7 6.5 15.2 8.6s11.4 5.4 13 11.1c-15 7.1-33.7 2.6-46.3-8.2"
      fill="#e5e289"
    />
    <path
      d="M1276.8 176.5c6.5.2 12.8 1.3 19.3 1.9 10.6 1 21.2.7 31.8.4 8.6-.2 17.8-.2 25.1 4.5 5.1 3.3 8.9 9.5 7.4 15.4-.9 3.4-3.3 6.2-6.2 8.2a32.6 32.6 0 0 1-22.3 4.3c-7.7-.9-15.1-3.5-22.7-5.1-15-3.3-30.6-3.1-45.9-4.7a60.3 60.3 0 0 1-31.6-10.3c-1.9-1.5-3.8-4-2.5-6"
      fill="#e2e6cf"
    />
    <path
      d="M1243.8 189.1c7.4-2.4 14.9-4.8 22.6-6.2a67.5 67.5 0 0 1 23.2-.3c8 1 15.9 1.4 24 1.2 7-.1 14.5-1 21.3.9 5.5 1.5 12.2 6.6 10.2 13.2-1.9 6.3-9.9 8.5-15.7 8.7-7.5.2-14.7-2.4-22-4.1-7.6-1.8-15.5-2.4-23.2-2.9-8.3-.6-16.7-.8-24.8-2.8-3.6-.9-7.2-2.1-10.4-4l-3.8-2.5c-.2-.2-1.2-.6-1.2-.9l.4-.6c1.4-1.4-.8-3.5-2.1-2.1-.8.9-1.5 2.2-1.3 3.4.3 1.2 1.4 2.1 2.4 2.7 2.6 1.8 5.2 3.4 8.1 4.7 7.1 3 14.8 3.9 22.3 4.5 8.5.7 17 .9 25.5 2.1 8.3 1.2 16.2 4.2 24.5 5.2 7.1.9 15 0 20.5-5 2.5-2.2 4.2-5.4 4.1-8.8-.1-3.3-1.7-6.4-4-8.8-5.1-5.3-12.9-6.2-19.8-6.2-8.6 0-17.1.5-25.7 0-8.5-.6-16.8-2.3-25.3-1.6-8.5.7-16.7 2.9-24.8 5.4l-5.9 1.9c-1.7.6-1 3.5.9 2.9z"
      fill="#e5e289"
    />
    <path fill="#eadb9d" d="m787.8 578 4.2-22-247 3 15.9 19z" />
    <g fill="none" stroke="#eadb9d" stroke-miterlimit="10">
      <path
        d="M1444.2 410V290.5M1454.2 410V290.5M1464.2 410V290.5M1474.2 410V290.5M1484.2 410V290.5M1494.2 410V290.5"
      />
    </g>
    <path
      fill="none"
      stroke="#eadb9d"
      stroke-miterlimit="10"
      d="M954.6 610v-58.3M964.6 610v-58.3M974.6 610v-58.3M984.6 610v-58.3M994.6 610v-58.3M1004.6 610v-58.3M1014.6 610v-58.3"
    />
    <path
      fill="#d3c794"
      d="M1371.2 516h73.8V291h-73.8v-33h-225.5v38h-1.2v256h226.7z"
    />
    <path
      d="M1145 296h-73.5a46 46 0 0 0-85.7 13H812v243h25.3v19h93v-19h109.2v21h85.9v-21h19V314h.5v-18z"
      fill="#cecaba"
    />
    <g
      fill="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    >
      <path stroke="#b3b3b3" stroke-width=".3" d="M632.7 528h6.8v6.1h-6.8z" />
      <path stroke="gray" stroke-width=".4" d="M631.1 534.1h10v4.8h-10z" />
    </g>
    <path
      d="M376 235.8c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM366 215.8c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM517.5 285.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM467.5 318.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM482.5 333.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM418.5 270.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM466.5 278.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM468.5 255.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM489.5 259.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM479.5 259.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM499.5 239.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM489.5 219.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM473.5 219.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM490.5 199.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM441.5 286.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM441.5 340.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM477.5 275.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM452.5 273.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM461.5 248.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM440.8 274.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.5-.9-1.4-.9-2.1-.3zM395.5 237.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM378.5 252.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.2 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.8-1.5-.8-2.1-.2zM387.5 221.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM476.5 238.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM451.5 297.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM454.5 326.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM477.5 291.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM492.5 291.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM502.5 271.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM512.5 261.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM562.5 261.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM572.5 251.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.8-1.5-.8-2.2-.2zM572.5 241.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.5-.7-2.2-.1zM592.5 251.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.8-1.5-.8-2.2-.2zM572.5 261.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM582.5 279.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM579.5 272.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM599.5 262.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM609.5 242.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.5-.7-2.2-.1zM629.5 252.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.2 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.8-1.5-.8-2.2-.2zM628.5 266.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM608.5 271.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM658.5 271.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM668.5 281.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM658.5 291.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM688.5 291.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM678.5 297.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM688.5 387.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM698.5 392.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM718.5 392.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM708.5 386.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM673.5 288.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM682.5 279.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.5-.9-2.2-.3zM502.5 251.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.8-1.5-.8-2.1-.2zM512.5 231.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.5-.7-2.2-.1zM483.5 241.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM503.5 211.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM503.5 191.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM492.5 180.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM522.5 200.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.5-.7-2.2-.1zM502.5 220.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM522.5 220.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.5-.7-2.2-.1zM512.5 240.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.5-.7-2.2-.1zM532.5 250.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5v-.4.5-.4l-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.8-1.5-.8-2.2-.2zM387.5 266.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM357.5 246.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM351.5 226.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM361.5 230.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM361.5 200.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2 .4.3.8.4 1.3.4a2 2 0 0 0 1.1-.3l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.7-1.5-.7-2.1-.1zM395.5 253.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM405.5 273.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM405.5 283.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM425.5 283.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM415.5 303.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM435.5 303.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM435.5 323.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM428.5 314.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM445.5 317.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM464.5 334.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM454.5 354.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3zM467.5 302.4c-.8.8-1.5 1.7-2 2.8-.3.7-.5 1.3-.6 2 0 .8.2 1.6.9 2a2 2 0 0 0 2.4.2l1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.1-.4.1.5v-.4.5-.4l-.1.4.1-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.1.4-.1-.3v.4-.5.4c0-.4.2-.7.3-1.1l-.1.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.6-.9-1.5-.9-2.1-.3z"
      fill="#e5e289"
    />
    <path
      d="M540.2 404.1c9.6-.5 18.2-5.9 27.4-8.3 21.8-5.7 44 5.6 65.6 11.9 22.9 6.7 47 7.9 70.9 9.1 6.5.3 14.7-.4 16.8-6.6 1.7-4.8-1.9-10.1-6.5-12.3-4.6-2.2-9.8-2.3-14.9-2.9-8.4-1-16.6-3.4-24.1-7.2-4.7-2.4-9.7-6.9-8.1-11.9s8.4-5.6 12.5-8.9c8.1-6.5 3.2-19.7 6.9-29.4 1.5-4.1 4.6-7.5 6-11.6 3.6-10.4-5.5-22.1-16.3-24.2-7.7-1.5-16.8.2-22.3-5.3-7.2-7.2-3.7-22.8-13.2-26.2a15 15 0 0 0-7.6-.2 314.2 314.2 0 0 0-54.2 12c-3.2 1-6.8 2.1-10 .8-2.5-1-4.2-3.4-5.5-5.7-4-6.7-6.4-14.4-7.1-22.1-.5-5.1-.2-10.2-1.7-15.1a22 22 0 0 0-20.7-15.1c-3.2 0-6.5.9-8.7 3.1-2.1 2.1-2.9 5-3.7 7.8a603.5 603.5 0 0 1-14.8 45.5c-3.6 9.8-9 20.8-19.2 23-9.1 2-18.3-4.5-22.9-12.7-4.6-8.1-6-17.6-8.1-26.7-1.8-7.5-4.2-14.8-7.3-21.9-.7-1.7-1.6-3.5-3.1-4.4a9.6 9.6 0 0 0-4.5-1c-7.7-.3-15.9 1.2-21.4 6.6-5 4.9-6.9 12.3-6.2 19.2.8 6.9 3.9 13.4 7.9 19.1 8.5 12.2 20.5 21.4 30.4 32.5 20.1 22.5 31.2 52.3 53 73.2 10.1 8.2 21.6 16.6 34.7 15.9z"
      fill="#c4afd9"
    />
    <path
      d="M561.3 397.3c3.7-2.5 8.8-1 13 .7 32.2 13.2 60.4 34 89.8 52.6 9.1 5.8 18.9 11.5 29.7 11.5a31 31 0 0 0 29.5-34.4c-.5-3-1.4-6-3.2-8.5-6.3-8.7-19.3-7.5-29.9-6.1-9 1.2-18.3 2.1-27.1-.2-8.8-2.3-17.1-8.2-20-16.9-3.1-9.2.5-19.2 4-28.2l5-13a131 131 0 0 1 10.2-22.2c1.3-2.1 2.8-4.3 3.4-6.7.7-2.4.5-4.9.2-7.3-1.2-10.2-6.2-20.7-15.5-25-9.3-4.3-22.8 1-23.8 11.2-.3 2.6.3 5.4-.7 7.9-2.3 6.2-11.2 5.9-17.7 4.5-8.9-2-18.3-4.3-24.3-11.1a42.6 42.6 0 0 1-7.5-15.6c-.5-1.7-1.2-3.6-2.8-4.5a6.4 6.4 0 0 0-4.1-.5 116.6 116.6 0 0 0-39.1 12.7l-11.3 5.2c-11.2 5.1-24 12.8-24.2 25-.2 11.7 11.3 19.7 21.4 25.7s21.3 14.7 20.2 26.3c-.1.9-.3 1.9-1 2.5-.7.6-1.6.7-2.5.8-10.6.6-20-6-29.1-11.4-9.1-5.4-20.6-9.8-30-4.8-6.1 3.3-9.7 10-10.9 16.8-1.2 6.8-.3 13.8.5 20.7.9 7 1.8 14.1 4.7 20.5 5.9 13.1 19.1 21.3 27.7 32.8 7.8 10.5 11.6 23.5 19.2 34.2 7.4 10.4 18 18 27 27s17 20.5 16.6 33.3l.1-.6c0-.5 0-1.1.2-1.6l-.2 1.6c.1 1.8 1.4 3.5 3.1 4.4 2.1 1.2 4.7 1.2 7.1 1.3 4.1.1 8.3.1 12.2-1.3 11.5-4.2 14.6-18.5 20.1-29.5 3.2-6.5 7.8-12.2 11.8-18.1a145 145 0 0 0 19.2-41c1.3-4.4 1.7-10.4-2.4-12.4-1.7-.8-3.6-.7-5.5-.6-24.6.5-45-18.3-60.5-37.4-2.4-3-4.9-6.2-5.9-9.9s.1-8.3 3.3-10.4z"
      fill="#e2e6cf"
    />
    <path
      d="M649.8 295.2c-1.8-.8-3.9-1.1-5.9-1.1-4.1-.1-8.4.8-11.7 3.3a11.4 11.4 0 0 0-4.5 10.9s1.1 5.4 2.1 9c1 3.6 3 7 6.3 8.9 6 3.3 13.8.1 20.1 2.6 1.3.5 2.7 1.3 4 1 1.8-.4 2.6-2.4 3.1-4.1.7-2.4 1.4-4.9 1.4-7.4.1-5.9-3.4-11.2-7.1-15.9a20 20 0 0 0-7.8-7.2z"
      fill="#d1d9ae"
    />
    <path
      d="M645.6 357.6c1.7-1.2 2.9-3 4-4.8a118.7 118.7 0 0 0 10.9-23c.3-3.9-3.7-6.6-5.8-9.9-1.3-2.1-1.8-4.6-3.3-6.5-2.8-3.4-8.2-3.6-12.2-1.6s-6.7 5.7-9.2 9.4c-1.3 2-2.7 4.1-3.2 6.5-.4 2-.2 4 0 6 .8 7.6 1.7 15.3 4.8 22.3h-.2c4.1 3.3 10.1 4.5 14.2 1.6z"
      fill="#fff"
    />
    <path
      d="M650.8 320.6c-.9-1.2-1.8-2.5-3.1-3.2s-3.2-.8-4.2.3c-.5.5-.8 1.2-1 1.9-1.2 4-1 8.3.6 12.1.6 1.3 8.6 2.9 9.8 2.1 1.5-1 3-2.1 3.8-3.7.9-1.6.9-3.8-.5-4.9-.7-.6-1.5-.9-2.3-1.3a9.7 9.7 0 0 1-3.1-3.3z"
      fill="#ffe0cc"
    />
    <path
      d="M697 430.7c-1.1.1-2.2.3-3.1.9-.7.5-1.2 1.2-1.7 2-2.5 4.2-3.2 9.2-5.1 13.7s-8.3 14.2-5.9 15c2.4.8 5 .8 7.5.8 4.3 0 8.6 0 12.7-1.2a38 38 0 0 0 13.5-8.1c2.2-1.8 4.4-4 4.6-6.8.3-3-1.9-5.7-4-7.9-1.9-2-4-3.9-6.3-5.3a18.8 18.8 0 0 0-12.2-3.1z"
      fill="#d1d9ae"
    />
    <path
      d="m689 452.2 3.4 1.1c3.7.9 7.8.2 11-1.8a6.5 6.5 0 0 0 2.8-2.9c.9-1.6.8-3.6.7-5.5-.2-3.2-.7-7-3.6-8.5-1.7-.9-3.7-.7-5.6-.4l-9.1 1.2c-2.5.3-5.1.7-7.2 2a8.7 8.7 0 0 0-3.7 6.5c0 2.2 8.3 7.2 11.3 8.3z"
      fill="#b2c075"
    />
    <path
      d="M612.2 418.8c7 3.7 13 9.2 19.7 13.4 7.1 4.4 15.1 7.4 21.7 12.6 2.5 1.9 4.8 4.2 7.7 5.3 2.9 1.1 6.8.8 8.5-1.8 1.9-2.8.5-6.8-2-9.2-2.5-2.4-5.7-3.7-8.5-5.6a45 45 0 0 1-6.8-6.3l-24.1-25.5a13.7 13.7 0 0 0-5.5-4.1 12 12 0 0 0-4.2-.3c-4.2.3-8.5 1.3-11.7 4-3.2 2.7-5 7.4-3.2 11.2l-.4-1.2c1.1 3.8 5.3 5.6 8.8 7.5z"
      fill="#d1d9ae"
    />
    <path
      d="M641.6 423.2c4.1 1.7 7.9 4.1 12 5.8s8.8 2.5 13 .9a6 6 0 0 0 3-2.2c1.2-1.7 1-4 .2-5.8s-2.5-3.2-4.1-4.4a29.6 29.6 0 0 0-6.8-3.6c-2.9-1.1-6-1.7-8.7-3.3-1.8-1.1-3.4-2.5-5.3-3.5-3.8-2-8.3-1.8-12.5-1.6-2.4.1-4.9.3-6.8 1.8-2 1.5 10.1 13.5 16 15.9z"
      fill="#c4afd9"
    />
    <path
      d="M522.5 435c.6 3 .6 6.3 1.8 9.1 2 4.6 6.7 7.4 11.4 9.2 2.5 1 5.1 1.9 7.8 1.9s5.5-.8 7.2-2.9c1-1.1 1.6-2.5 2-4 1.2-4.4.2-9.2-1.8-13.3s-5-7.6-8-11a458.5 458.5 0 0 0-33.9-33.6 11 11 0 0 0-4.8-1.1c-7.8-.2-15.9 3.3-19.7 10.1-1.1 1.9-1.8 4-2.3 6.1-.9 3.8-1.2 8 .6 11.5 1.6 3.2 4.9 5.5 8.4 6.5s7.2 1.2 10.8 1c3.2-.1 6.4-.4 9.5.1 2.8.4 5.5 1.6 7.3 3.7 2 1.7 3.2 4.2 3.7 6.7z"
      fill="#fff9e7"
    />
    <path
      d="M481.5 394.8c-2.7-2.5-6-4.4-9.6-4.8s-7.5 1.4-9.1 4.6a14 14 0 0 0-.6 7.6A75.3 75.3 0 0 0 472 433c4.4 7.2 10.5 13.2 16.5 19.2.5.5 1.2 1.1 1.9.9v-.6c6.1-11.2 9.9-24.7 5.2-36.6-1.3-3.4-3.3-6.5-5.2-9.6-2.5-4-5.3-8.2-8.9-11.5z"
      fill="#d1d9ae"
    />
    <path
      d="M539.5 431.6c-1.5.2-2.2 1.9-3.3 3.1-1.2 1.3-6.7 4.2-5.9 5.6a8.3 8.3 0 0 0 3.6 3.1c3.7 1.9 8 2.5 12.1 2.5.4 0 .8 0 1.1-.2.6-.3.9-1.1.9-1.8.2-2.1-.9-4.1-2-5.9-1-1.6-2.1-3.1-3.3-4.6-.8-.9-1.9-2-3.2-1.8z"
      fill="#b0bd76"
    />
    <path
      d="M504.6 396.6c-2.1-1.1-4.7-2-7-1.2s14 18.1 20.7 25.7c2.4 2.8 4.9 6.3 8.5 6.4 1.2 0 2.7-.5 2.9-1.7.2-.9-.3-1.7-.8-2.5-6.4-10.3-13.5-21-24.3-26.7z"
      fill="#c4afd9"
    />
    <path
      d="M551.7 489.3c3.2-1.3 6.3-2.9 9.1-4.8.6-.4 1.2-.8 1.4-1.4.4-.9.1-1.9-.4-2.8a16 16 0 0 0-10.3-7.6c-4.3-1-8.8-.8-13.2-.1-3.7.5-7.4 1.3-11 .5-3.2-.8-6-2.8-8.6-4.9s-5-4.4-8-6c-3-1.6-6.5-2.3-9.6-1.1-3.1 1.2-4.1 7.3-4.1 7.3-.4 2.8.6 5.7 2 8.2 1.6 2.9 3.8 5.6 5.2 8.6 1.3 2.9 1.9 6.2 3.6 8.9 1.6 2.6 4.2 4.4 6.2 6.7 2.2 2.6 3.7 5.8 5.9 8.6 2 2.5 4.4 4.6 6.9 6.7 1.8 1.5 3.9 3.2 6.3 3.3 2.7.1 5.1-1.7 7-3.7 2.3-2.3 4.3-5.1 4.8-8.3.7-4.9-2.4-10.4.5-14.4 1.5-1.9 4-2.8 6.3-3.7z"
      fill="#fff9e7"
    />
    <path
      d="M529.6 482.5c-2.9-.2-10.1 4.1-10.2 5.6-.2 2.3-.2 4.8 1.2 6.6a14.2 14.2 0 0 0 7.9 4.3c2.1.3 4.4-.2 5.9-1.8 1.8-1.9 2-4.9 1.9-7.6 0-1.8-.1-3.8-1.3-5.2-1.3-1.4-3.4-1.7-5.4-1.9z"
      fill="#ffe0cc"
    />
    <path
      d="M516.2 350.2c1.4-.4 2.8-.9 3.7-2 1.3-1.4 1.5-3.5 1.7-5.5a76 76 0 0 0-2.4-32.6c-.8-2.1-2-4.4-4.1-5.2-1.7-.7-3.5-.3-5.2.2a53.8 53.8 0 0 0-22.4 16 9 9 0 0 0-.8 4.6c.1 5.8 2.8 11.2 6.1 16 2.7 4.3 19.4 9.6 23.4 8.5z"
      fill="#d1d9ae"
    />
    <path
      d="M548.7 330.1c3.2-1.7 6.8-2 10.2-3.2 3.4-1.2 6.7-3.8 6.9-7.4.2-3.1-2.2-5.9-5-7.1-2.8-1.3-6-1.3-9.1-1.1-4.6.2-9.2.8-13.8 1.6-5.6 1.1-11.4 2.8-15.7 6.6s-6.5 10.5-3.8 15.6c2.5 4.7 19.5 4.5 22.1 2 2.7-2.5 5.1-5.4 8.2-7z"
      fill="#fff"
    />
    <path
      d="M553.2 343.1c1.5 1 3.3 1.6 5.1 2.2l14.4 4.6c3.7 1.2 7.4 2.4 11.2 2.5 9.4.4 18.7-6.2 21.5-15.2.6-1.9.9-3.9.3-5.8a9.2 9.2 0 0 0-2.7-4 17.7 17.7 0 0 0-10.2-4.6c-5.8-.5-11.9 1.9-17.5-.1-1.7-.6-3.2-1.6-4.9-2.2-2.7-1-5.7-.9-8.6-.9a8 8 0 0 0-3.8.7c-1 .6-1.8 1.5-2.5 2.5-2 2.7-5.8 8.9-5.8 8.9-1.6 4-.1 9 3.5 11.4z"
      fill="#d1d9ae"
    />
    <path
      d="M586 332.6c-.9-.7-2-1.2-3-1.7-2.2-1-4.4-2.1-6.8-2.4-4.1-.6-9.3 8.8-8.4 10.4.8 1.5 1.9 2.8 3.1 4 2.1 2.2 4.6 4.3 7.5 5.3 2.8.9 6 .7 8.5-.9s4-4.6 3.6-7.5c-.3-2-1.4-3.7-2.7-5.2-.6-.8-1.1-1.4-1.8-2z"
      fill="#ffe0cc"
    />
    <path
      d="M549 347.5a19.6 19.6 0 0 0-1.7 8.7c0 .8-.1 1.6.3 2.2.3.5.7.9 1.2 1.2l17 12.9a214 214 0 0 0 22.5 15.5c2.7 1.5 5.5 3 8.5 4.1a26.6 26.6 0 0 0 15.2 2 19.3 19.3 0 0 0 13.7-12.3 22 22 0 0 0-2.1-18.5c-1.3-2.1-3-4.1-3.4-6.6-.3-1.4-.1-2.9-.5-4.3-1-3.4-4.7-5-8-6.1-5.5-1.9-11.7-3.8-16.9-1.2-2.1 1-3.8 2.8-5.9 3.9-5.6 3-12.5 1.2-18.5-1.1-5.9-2.3-12.1-5-18.2-3.8a8.7 8.7 0 0 0-3.2 3.4z"
      fill="#c4afd9"
    />
    <path
      d="M549.7 389.8c.4.4.8.9 1.3 1.1.5.2 1.1.3 1.7.3 2 0 3.9-.3 5.8-.9 1.4-.5 3-1.3 3.3-2.7l.1-1.4c-.2-3.4-1.2-6.6-2.9-9.5a6 6 0 0 0-2.5-2.7c-.8-.4-1.7-.4-2.5-.4-2.3.1-4.6 1-6.2 2.7s-2 7.3-2 7.3c.9 2.2 2.2 4.3 3.9 6.2zM607 369.6c-1.3.7-2.8 1.3-4.2.9-1.1-.3-2-1.1-3.1-1.7a7 7 0 0 0-8.9 2.4c-.8 1.3-1.1 2.8-1.3 4.3-.6 3.5 13 17 20 16.7a15 15 0 0 0 8-2.3c1.8-1.2 3.2-3 4.3-4.9 1.9-3.1 3.5-6.6 3.3-10.2-.1-3.6-2.2-7.4-5.7-8.5-4.1-1.4-8.4 1.3-12.4 3.3z"
      fill="#b2c075"
    />
    <path
      d="m633.1 455.4-1.5-.3-18-1.5c-1.8-.1-3.9-.1-4.8 1.4-.4.7-.5 1.6-.8 2.5a8 8 0 0 1-2.7 3.1L592.2 471c-3.1 2.5-6.5 5.5-6.6 9.5 0 4.5 4.1 7.7 6.5 11.5 1.8 2.9 2.6 6.4 3.9 9.6s3.4 6.4 6.7 7.5c.9.3 2 .5 2.5 1.3.3.5.4 1.2.5 1.8l.7 7.3 2.2.8a1346 1346 0 0 1 9.8-15.7 101 101 0 0 0 3.8-6.5c2.9-5.3 5-10.9 7.2-16.5l4.5-11.7c1.7-4.4 3.3-9.8.4-13.5a3 3 0 0 0-1.2-1z"
      fill="#d1d9ae"
    />
    <path
      d="M618.7 472.1c-.4-.3-.9-.3-1.3-.4-4.5-.4-9.2 1.7-12 5.2-.3.5-.7.9-.8 1.5-.2.6-.2 1.3 0 2a7.3 7.3 0 0 0 2.7 4.4c1 .8 10.4-.2 11.8-3 1.1-2.2.9-4.7.7-7.1-.2-1-.3-2.1-1.1-2.6z"
      fill="#b2c075"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m587.5 316.2-2.7-2.9 2.7-2.6 2.8 2.6-2.8 2.9"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m587.5 316.2-2.7-2.9 2.7-2.6 2.8 2.6z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M592.5 313.3h-1l-4 4.1v1l5-5.1"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M592.2 313.6h0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M587.5 316.2v.2l3.1-3.1h-.3l-2.8 2.9"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M589.8 314v.3M589.4 314.8h0M589.4 314.5v.3M587.9 316l-.2.4M590.6 313.6h0M588.2 315.7v.3M588.9 315v.2M588.4 315.5v.2M588.4 315.5h0M588.7 315.2v.3M588.7 315.2h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M587.5 316.2v.2l3.1-3.1h-.3z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M582.5 313.4h2.3l2.7-2.7v-2.3l-5 5M592.5 313.4h-2.3l-2.7 2.7v2.3l5-5"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M582.5 313.4h2.3l2.7-2.7v-2.3l-5 5M592.5 313.4h-2.3l-2.7 2.7v2.3l5-5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M592.5 313.4h-2.3l-2.7-2.7v-2.3l5 5"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M591.8 312.6h0M588.2 311.2v.2M588.7 311.9h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M592.5 313.4h-2.3l-2.7-2.7v-2.3l5 5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M587.5 318.4v-2.3l-2.7-2.7h-2.3l5 5"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M585 313.6h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M587.5 318.4v-2.3l-2.7-2.7h-2.3l5 5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M584.6 313.4h.2l2.7-2.7v-.2l-2.9 2.9"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M584.6 313.4h.2l2.7-2.7v-.2l-2.9 2.9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M584.6 313.4h.2l2.7 2.7v.3l-2.9-3"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M584.6 313.4h.2l2.7 2.7v.3l-2.9-3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M590.5 313.4h-.3l-2.7-2.7v-.2l3 2.9"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M590.5 313.4h-.3l-2.7-2.7v-.2l3 2.9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M590.5 313.4h-.3l-2.7 2.7v.3l3-3"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M590.5 313.4h-.3l-2.7 2.7v.3l3-3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m642.7 389.2.9-4.2 5.2 2.3-2.6 3.4-3.5-1.5"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m642.7 389.2.9-4.2 5.2 2.3-2.6 3.4-3.5-1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m642.9 383.6.7 1.4-.9 4.2-1.1.5 1.3-6.1"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M642.8 389.3v.2M642.6 389.3v.2M641.9 389.8h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m642.9 383.6.7 1.4-.9 4.2-1.1.5 1.3-6.1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m642.7 389.2-1.1.5 5 2.2-.4-1.2-3.5-1.5"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M642.1 390h0M642.1 390h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m642.7 389.2-1.1.5 5 2.2-.4-1.2-3.5-1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m643.6 385 5.2 2.3 1.5-.4-7.4-3.3.7 1.4"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M649.3 387.4h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m643.6 385 5.2 2.3 1.5-.4-7.4-3.3.7 1.4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m650.3 386.9-1.5.4-2.6 3.4.4 1.2 3.7-5"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M649.8 387.6h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m650.3 386.9-1.5.4-2.6 3.4.4 1.2 3.7-5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m628.9 359.7-2.5 4.3h5l-2.5-4.3"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m628.9 359.7-2.5 4.3h5l-2.5-4.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m624.6 365 1.8-1h5l1.7 1h-8.5"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m624.6 365 1.8-1h5l1.7 1h-8.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M628.9 357.7v2l2.5 4.3 1.7 1-4.2-7.3"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M633 365h0M630.2 359.8h0M629.7 359h0M631.6 362.4h0M631.8 364.3h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M628.9 357.7v2l2.5 4.3 1.7 1-4.2-7.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M628.9 357.7v2l-2.5 4.3-1.8 1 4.3-7.3"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M628.9 357.7v2l-2.5 4.3-1.8 1 4.3-7.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M639.2 336.3v-3.1l-2.6-1.7-2.7 1.7v3.1l2.7 1.4 2.6-1.4"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M639.2 336.3v-3.1l-2.6-1.7-2.7 1.7v3.1l2.7 1.4z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M636.6 330.3v1.2l2.7 1.5 1-.5-3.7-2.2"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M639.9 332.7h0M639.7 332.9l-.2.3M637 331.7h0M636.8 331.5h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M636.6 330.3v1.2l2.7 1.5 1-.5-3.7-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m640.3 336.7-1-.5V333l1-.5v4.2"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M639.5 333.6v.5M639.5 333.2v.4M639.7 336.5h0M639.5 334.1v.7M639.5 336.3v.2M639.5 335.8v.5M639.5 335.3v.5M639.5 334.8v.5M639.5 334.8h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m640.3 336.7-1-.5V333l1-.5v4.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m640.3 336.7-1-.5-2.7 1.5v1.2l3.7-2.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m640.3 336.7-1-.5-2.7 1.5v1.2l3.7-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m632.9 336.7 1-.5 2.7 1.5v1.2l-3.7-2.2"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M634.7 336.8h0M636.6 338.9h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m632.9 336.7 1-.5 2.7 1.5v1.2l-3.7-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m632.9 336.7 1-.5V333l-1-.5v4.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m632.9 336.7 1-.5V333l-1-.5v4.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="M636.6 330.3v1.2l-2.7 1.5-1-.5 3.7-2.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M636.6 330.3v1.2l-2.7 1.5-1-.5 3.7-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M633.8 333h.1v3.2h-.1V333"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M633.8 333h.1v3.2h-.1V333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M633.8 333h.1l2.7-1.5v-.2l-2.8 1.7"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M633.8 333h.1l2.7-1.5v-.2l-2.8 1.7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M636.6 337.9v-.2l-2.7-1.5h-.1l2.8 1.7"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M636.6 337.9v-.2l-2.7-1.5h-.1l2.8 1.7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M639.4 333h-.1v3.2h.1V333"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M639.4 333h-.1v3.2h.1V333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M639.4 333h-.1l-2.7-1.5v-.2l2.8 1.7"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M639.4 333h-.1l-2.7-1.5v-.2l2.8 1.7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M636.6 337.9v-.2l2.7-1.5h.1l-2.8 1.7"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M636.6 337.9v-.2l2.7-1.5h.1l-2.8 1.7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#e6e6e6"
      d="M640.2 333.9v1.4z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m606.1 427.8-2.2-2.4v-3.1l2.2-2.1h3.1l2.2 2.1v3.1l-2.2 2.4h-3.1"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m606.1 427.8-2.2-2.4v-3.1l2.2-2.1h3.1l2.2 2.1v3.1l-2.2 2.4z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m606.6 426.6-1.5-1.6v-2.2l1.5-1.4h2.1l1.5 1.4v2.2l-1.5 1.6h-2.1"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m606.6 426.6-1.5-1.6v-2.2l1.5-1.4h2.1l1.5 1.4v2.2l-1.5 1.6z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m609.2 420.2-.4 1.2h-2.2l-.5-1.2h3.1"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M609.2 420.4h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m609.2 420.2-.4 1.2h-2.2l-.5-1.2h3.1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m609.2 420.2-.4 1.2 1.5 1.5 1.2-.5-2.3-2.2"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M609 421.4v.2M610.2 421.1h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m609.2 420.2-.4 1.2 1.5 1.5 1.2-.5-2.3-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m611.5 425.5-1.2-.5v-2.1l1.2-.5v3.1"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M610.4 425h0M610.4 424.2v.8M610.4 424.2h0M610.4 425v.2M610.4 424.2v.8"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m611.5 425.5-1.2-.5v-2.1l1.2-.5v3.1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m603.9 422.4 1.2.5 1.5-1.5-.5-1.2-2.2 2.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m603.9 422.4 1.2.5 1.5-1.5-.5-1.2-2.2 2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m606.1 427.7.5-1.2-1.5-1.5-1.2.5 2.2 2.2"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M605.4 425.2v.2M606.3 426.4h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m606.1 427.7.5-1.2-1.5-1.5-1.2.5 2.2 2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m606.1 427.7.5-1.2h2.2l.4 1.2h-3.1"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M609.2 427.6h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m606.1 427.7.5-1.2h2.2l.4 1.2h-3.1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m611.5 425.5-1.2-.5-1.5 1.5.4 1.2 2.3-2.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m611.5 425.5-1.2-.5-1.5 1.5.4 1.2 2.3-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#fff"
      d="m603.9 422.4 1.2.5v2.1l-1.2.5v-3.1"
    />
    <path
      fill="none"
      stroke="#555"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M605.1 422.8v.5M604.2 422.6h0"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m603.9 422.4 1.2.5v2.1l-1.2.5v-3.1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m605 422.8.1.1v2.1l-.1.1v-2.3"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m605 422.8.1.1v2.1l-.1.1v-2.3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m605 422.8.1.1 1.5-1.5v-.1l-1.6 1.5"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m605 422.8.1.1 1.5-1.5v-.1l-1.6 1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M608.8 421.3v.1h-2.2v-.1h2.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M608.8 421.3v.1h-2.2v-.1h2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M608.8 421.3v.1l1.5 1.5.1-.1-1.6-1.5"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M608.8 421.3v.1l1.5 1.5.1-.1-1.6-1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M606.6 426.7v-.2l-1.5-1.5-.1.1 1.6 1.6"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M606.6 426.7v-.2l-1.5-1.5-.1.1 1.6 1.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="M606.6 426.7v-.2h2.2v.2h-2.2"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="M606.6 426.7v-.2h2.2v.2h-2.2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m610.4 425.1-.1-.1-1.5 1.5v.2l1.6-1.6"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m610.4 425.1-.1-.1-1.5 1.5v.2l1.6-1.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      fill="#f3f3f3"
      d="m610.4 425.1-.1-.1v-2.1l.1-.1v2.3"
    />
    <path
      fill="none"
      stroke="#000"
      stroke-width=".1"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      d="m610.4 425.1-.1-.1v-2.1l.1-.1v2.3"
    />
    <path
      d="M888.2 656.6c-22.8 2.2-45.9 18.8-68 17.3-14.5-1-25.5-9.7-39.2-12.8-8.8-2-18.5-1.8-28.1-1.4-9.7.3-20.1.9-28.9 6.5-8.8 5.6-14.1 18.2-7.5 23.7l1.2.3c9 0 15.6 5.5 23.3 8.5a81.8 81.8 0 0 0 18.2 4l64.2 9.1c6.3.9 12.7 1.8 19.2 1.9 7.6.1 15.4-.9 22.9-.5 21.3 1.1 38 13 58.2 17.1 8.2 1.7 18.6 1.4 25.2-5.3 4.9-5 5.9-11.9 6.1-18 .3-12.9-2-26.3-11.6-33.7a48.3 48.3 0 0 0-10.5-5.7c-13.7-6.4-28.2-12.6-44.7-11z"
      fill="#d1d9ae"
    />
    <path
      d="M723.8 680.1c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM726.6 683.9c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM728.6 679.6c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM726.9 676c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM730.5 676.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM732.2 681.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM733.2 678.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM734.2 684.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM736.2 680.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM730.5 684.7c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM734.5 675.5c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM811.8 701.1c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM814.6 704.9c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM816.6 700.6c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM814.9 697c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM818.5 697.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM820.2 702.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM821.2 699.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM822.2 705.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM824.2 701.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM818.5 705.7c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM822.5 696.5c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM791.8 670.1c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM794.6 673.9c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM796.6 669.6c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM794.9 666c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM798.5 666.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM800.2 671.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM801.2 668.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM802.2 674.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM804.2 670.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM798.5 674.7c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM802.5 665.5c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM887.6 659c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM890.4 662.9c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM892.5 658.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM890.7 654.9c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM894.3 655.4c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM896 660.6c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM897 657.6c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM898 663.6c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM900 659.6c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM894.3 663.6c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM898.4 654.4c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM928.8 721.1c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM931.6 724.9c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM933.6 720.6c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM931.9 717c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM935.5 717.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM937.2 722.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM938.2 719.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM939.2 725.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM941.2 721.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM935.5 725.7c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM939.5 716.5c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2z"
      fill="#c4afd9"
    />
    <g>
      <path
        d="M432.2 254.7c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M432.1 254.5c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M432 254.4c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M432.2 254.2c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M432.2 254.5c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M431.9 254.6c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M440.8 256.7c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M440.7 256.5c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M440.7 256.4c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M440.9 256.2c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M440.8 256.5c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M440.6 256.7c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.3-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M434.8 245.3c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M434.7 245c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M434.6 244.9c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M434.8 244.8c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M434.7 245.1c-.1.7-.5 1.3-.9 1.8s-1 .9-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M434.5 245.2c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M424.5 260.2c-.5-.5-.7-1.2-.8-1.9s0-1.4 0-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.4 260c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.4 259.9c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M424.5 259.7c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.5 260c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.2 260.2c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.3.7-1.1 1.2-1.9 1.6"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M436.5 264.2c-.5-.5-.7-1.2-.8-1.9s0-1.4 0-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M436.4 264c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M436.4 263.9c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M436.5 263.7c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M436.5 264c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M436.2 264.2c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.3.7-1.1 1.2-1.9 1.6"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M443.8 248.8c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M443.7 248.6c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M443.7 248.5c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M443.8 248.3c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M443.8 248.6c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M443.5 248.7c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M424.5 249.6c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.4 249.4c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.4 249.2c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2c-.1-.4-.5-.6-.8-1-.5-.6-.7-1.5-.8-2.4M424.5 249.1c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.5 249.4c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M424.3 249.5c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M535.5 240.6c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M535.4 240.4c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M535.4 240.2c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M535.5 240.1c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M535.5 240.4c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M535.3 240.5c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M539.5 231.6c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M539.4 231.4c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M539.4 231.2c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M539.5 231.1c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M539.5 231.4c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M539.3 231.5c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M529.5 232.6c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M529.4 232.4c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M529.4 232.2c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M529.5 232.1c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M529.5 232.4c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M529.3 232.5c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M544.5 244.6c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M544.4 244.4c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M544.4 244.2c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M544.5 244.1c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M544.5 244.4c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M544.3 244.5c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M526.5 244.6c-.5-.5-.7-1.2-.8-1.9v-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M526.4 244.4c-.7.2-1.4 0-2-.2s-1.2-.7-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M526.4 244.2c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M526.5 244.1c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M526.5 244.4c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M526.3 244.5c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M600.3 383.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM603.1 387.5c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM605.2 383.1c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM603.4 379.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM607 380.1c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM608.7 385.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM609.7 382.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM610.7 388.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM612.7 384.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM607 388.2c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM611.1 379.1c1.5 0 1.5-2.2 0-2.2-1.5-.1-1.5 2.2 0 2.2z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M844.3 281.6c1.5 0 1.5-2.2 0-2.2-1.4 0-1.4 2.2 0 2.2zM847.1 285.5c1.5 0 1.5-2.2 0-2.2s-1.4 2.2 0 2.2zM849.2 281.1c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM847.4 277.5c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM851 278.1c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM852.7 283.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM853.7 280.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM854.7 286.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM856.7 282.2c1.5 0 1.5-2.2 0-2.2-1.4-.1-1.4 2.2 0 2.2zM851 286.2c1.5 0 1.5-2.2 0-2.2s-1.5 2.2 0 2.2zM855.1 277.1c1.5 0 1.5-2.2 0-2.2-1.5-.1-1.5 2.2 0 2.2z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M1194 180.7c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1198 189.5c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1200.9 179.5c1.4 0 1.4-2.2 0-2.2-1.5 0-1.5 2.2 0 2.2zM1198.4 171.3c1.4 0 1.4-2.2 0-2.2s-1.5 2.2 0 2.2zM1203.5 172.5c1.4 0 1.4-2.2 0-2.2s-1.5 2.2 0 2.2zM1206 184.2c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1207.5 177.3c1.4 0 1.4-2.2 0-2.2s-1.5 2.2 0 2.2zM1208.9 191.1c1.4 0 1.4-2.2 0-2.2-1.5-.1-1.5 2.2 0 2.2zM1211.7 181.9c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1203.5 191.2c1.4 0 1.4-2.2 0-2.2s-1.5 2.2 0 2.2zM1209.3 170.2c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M1570.2 284.9a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.6-.9-2.2-.3z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1592.2 299.9a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.6-.9-2.2-.3z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1605.2 298.9a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.6-.9-2.2-.3z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1554.2 289.9a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.6-.9-2.2-.3z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M862.3 187.5c.4 1 .8 2.1 1.8 2.6.9.5 2.1.4 2.8-.4.5-.6.5-1.4.2-2-.1-.4-.5-.6-.9-.5-.4.1-.6.5-.5.9l.1.2v.1-.1V188.6v-.1.2c0-.1 0-.1 0 0v.1c-.1.1.1-.1 0 0l-.1.1c-.1.1 0 0 .1 0l-.1.1h-.1.1l-.3.1c.2-.1.1 0 0 0H865.1h.1H864.9h.1l-.2-.1c-.1-.1-.1 0 0 0l-.1-.1-.1-.1-.1-.1c-.1-.1.1.1 0 0l-.4-.6-.1-.2v-.1.1l-.2-.4c-.1-.4-.5-.7-.9-.5-.4-.3-.7.1-.6.5z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M868.2 192.6c-.2.5-.3 1-.1 1.6.1.4.4.9.7 1.2.4.3.9.6 1.5.5.6 0 1.1-.3 1.5-.6.5-.4.7-1 .8-1.6 0-.4-.4-.8-.8-.8s-.7.3-.8.8c0 .2 0-.1 0 0v.2-.1l-.1.1-.1.1c.1-.1.1-.1 0-.1v.1l-.1.1c-.2.1.1-.1 0 0l-.3.2c.1-.1.1-.1.1 0H870.2c-.2 0 .1 0 0 0H869.9h.1H869.7h.1l-.1-.1-.1-.1c.2.1.1.1 0 0l-.1-.1c-.1-.1.1.1 0 0l-.2-.2c-.1-.1.1.2 0 0v-.2c.1.2 0 .1 0 0v-.1c0-.2 0 .1 0 0v-.1c0-.1.1-.2 0 0l.1-.6c0-.2-.2-.4-.3-.4-.1-.2-.7-.2-.9.2z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M870.7 187.9c-.6.4-.7 1.1-.5 1.8.2.5.5 1 .9 1.4.4.4 1 .7 1.6.6.6-.1 1.1-.4 1.5-.9l.3-.9c0-.4-.1-.7-.4-1a1 1 0 0 0-.5-.2l-.5.2-.2.5.2.5c-.2-.2 0-.1 0 0l-.1-.2v.2-.2.2-.2l-.1.2.1-.2-.1.2c-.1.1.1-.1 0 0l-.1.1-.1.1c-.1.1.2-.1 0 0l-.2.1.2-.1-.2.1h.2-.3.2l-.3-.1.2.1-.3-.2c.2.1.1.1 0 0l-.1-.1-.1-.1-.1-.1c.2.2.1.1 0 0l-.1-.2-.2-.4.1.2-.1-.4v.2-.3.2-.1l-.1.2v-.1l-.1.1c.1-.1-.1.1 0 0 .3-.2.5-.7.3-1-.2-.2-.7-.4-1-.2z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M861.7 194.8c-.3 1.1.3 2.2 1.4 2.6 1 .4 2.1-.1 2.6-.9.2-.3.1-.8-.3-1-.4-.2-.8-.1-1 .3 0 0-.1.2 0 .1l-.1.1.1-.1-.1.1-.1.1h.1-.1l-.3.1h.2-.3.2H863.7c.2.1.1.1 0 0l-.2-.1c.2.1 0 0 0-.1l-.1-.1.1.1v-.1l-.1-.2c-.1-.1.1.2 0 .1V195.5v.2-.4.2-.1c.1-.4-.1-.8-.5-.9-.7-.3-1.1-.1-1.2.3z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M867.4 198.2c.2.7.8 1.3 1.6 1.5h1.1c.4-.1.8-.4 1-.8l.1-.6c0-.2-.2-.4-.3-.4l-.6-.1c-.2 0-.3.2-.5.3l.1-.1-.2.2.2-.1-.2.1.2-.1-.3.1h.2-.4.2l-.4-.1.2.1-.3-.2.2.1-.2-.2.1.1-.1-.2.1.2-.1-.2c-.1-.4-.5-.6-.9-.5-.6.1-.9.5-.8.9z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M867.3 180.5a3 3 0 0 0 1.3 4.3c.3.1.7.1.9-.1l1.1-1.2c.3-.3.3-.8 0-1.1a.8.8 0 0 0-1.1 0l-1.1 1.2.9-.1-.4-.2c.1.1.1.1 0 0l-.1-.1-.1-.1c0-.1-.1-.1 0 0l-.1-.1-.1-.2-.1-.1c0-.1 0-.2 0 0l-.1-.2-.1-.2v-.1c0-.2 0 .1 0 0v-.4.1-.1l.1-.2v-.1c0-.1-.1.2 0 0l.1-.2c.2-.3.1-.8-.3-1-.2-.3-.6-.1-.8.2z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M873.4 185.5c.2.8 1 1.3 1.8 1.4a2 2 0 0 0 1.1-.3c.4-.3.6-.6.8-1v-1.2l-.3-.4-.6-.1-.5.3c-.1.1-.2.4-.1.6l.1.3v-.2.3-.2l-.1.3.1-.2-.2.3.1-.1-.2.2.2-.1-.2.1.2-.1-.2.1h.2-.3.2l-.3-.1.2.1-.3-.2.2.1-.2-.2.1.1-.1-.2.1.2v-.2c-.1-.4-.5-.6-.9-.5-.8.1-1 .4-.9.9z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M874.9 193.2c-.8.8-.6 2.2.3 3 .4.4 1 .6 1.6.6.7-.1 1.2-.4 1.7-.8a4 4 0 0 0 1-1.8c.1-.4-.1-.8-.5-.9-.4-.1-.8.1-.9.5l-.1.3s-.1.2 0 .1c0-.1 0 0 0 0v.1l-.2.3-.1.1v.1c-.1.1.1-.1 0 0l-.2.2-.1.1c-.1.1.1-.1 0 0l-.3.1h-.1s.2-.1.1 0l-.2.1h-.1c-.2 0 .1 0 0 0h-.1s-.2 0 0 0h-.1c-.1 0 .2.1 0 0l-.1-.1-.1-.1s.1.1.1 0l-.1-.1s-.1-.2 0-.1l-.1-.1-.1-.1s.1.2 0 .1V194.5v.1-.1s0-.2 0 0v-.1c0-.1-.1.1 0 0l.1-.1-.1.1.1-.1c.3-.3.3-.8 0-1.1-.7-.3-1.1-.3-1.4 0z"
        fill="#fff"
      />
    </g>
    <g>
      <path
        d="M1228.8 166.8a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1238.8 176.8a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1259.6 162.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1239.6 166.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1218.6 177.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1218.6 197.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1206.6 195.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1368.6 177.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1348.6 167.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1368.6 157.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1378.6 183.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1389.6 167.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1369.6 167.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.4 1.3.4l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2l-.4-.1.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4.4-.1h-.2l.4.1h-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.7-1.6-.7-2.2-.1z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M1549.3 427.8c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1553.3 436.5c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1556.2 426.6c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1553.7 418.4c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1558.8 419.6c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1561.4 431.3c1.4 0 1.4-2.2 0-2.2-1.5-.1-1.5 2.2 0 2.2zM1562.8 424.4c1.4 0 1.4-2.2 0-2.2-1.5 0-1.5 2.2 0 2.2zM1564.2 438.1c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1567.1 429c1.4 0 1.4-2.2 0-2.2s-1.5 2.2 0 2.2zM1558.8 438.3c1.4 0 1.4-2.2 0-2.2s-1.4 2.2 0 2.2zM1564.7 417.3c1.4 0 1.4-2.2 0-2.2-1.5-.1-1.5 2.2 0 2.2z"
        fill="#fff"
      />
    </g>
    <path fill="#cecaba" d="M792 358h41v66h-41z" />
    <g
      fill="#fff"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
    >
      <path stroke="#b3b3b3" stroke-width=".3" d="M708.3 592.5h6.8v6.1h-6.8z" />
      <path stroke="gray" stroke-width=".4" d="M706.8 587.7h10v4.8h-10z" />
    </g>
    <g fill="#fff9e7">
      <path d="M718 737h-52v22.1l1.6 1.9H718z" />
      <path d="M666 737h-15l2 10 12 16 8-5-2-18z" />
    </g>
    <g>
      <path
        d="M632.9 651.5c-3.8-3.9-9.3-4.4-13.1-8.3-1.8-1.8-3-4.4-3.5-7.1-.3-1.4-.3-2.8-.8-4.2-.4-1.2-1.1-2.2-1.8-3.2-5.1-6.9-11-12.7-17-18.5-2.6-2.6-7.7-2-6.6.4 3 6.3 6.1 12.7 9.9 18.4 4.4 6.6 10 12.4 12.2 20.5 1.1 3.9 1.3 8.3 3.3 11.7 3.9 6.8 13.2 7 16.2 14.5.7 1.7.9 3.7 1.6 5.4.7 1.7 2.1 3.2 3.6 3 2.1-.3 3-3.5 3-6.1.1-4.2-.6-8.3-1.4-12.3-.9-5.3-2.2-10.8-5.6-14.2z"
        fill="#d2d7bc"
      />
    </g>
    <g>
      <path
        d="M590.5 524.3c-4.7-4.1-9.5-8.3-15.5-10-4.5-1.2-9.4-.9-13.7 1a13 13 0 0 0-4.1 2.8c-1.3 1.5-1.9 3.5-2.5 5.5a91 91 0 0 0 3 26.8c.5 1.4 1 2.8 2 3.9a11 11 0 0 0 4.6 2.6 22 22 0 0 0 11.5 2.1c3-.5 5.7-2.2 8.2-4 4.3-2.9 8.9-6 10.7-10.8a24 24 0 0 0 .6-11c-.2-1.7-.5-3.5-1.3-5.1-.8-1.4-2.2-2.6-3.5-3.8z"
        fill="#c4afd9"
      />
    </g>
    <g>
      <path
        d="M502.7 421.2c2.5.2 5.6-.4 6.6-2.7.4-.9.5-1.9.4-2.8-.1-3.2-.8-6.3-2.2-9.2a6.4 6.4 0 0 0-2.6-3c-.9-.4-1.8-.5-2.8-.5-3.1-.1-6.7-.1-8.9 2.1a7.4 7.4 0 0 0-1.7 6.4c.5 2.3 7.9 9.5 11.2 9.7z"
        fill="#d1d9ae"
      />
    </g>
    <g>
      <path
        d="M550 331a26 26 0 0 0 3.3-1.9c.9-.6 1.8-1.3 2.4-2.3 1.2-1.9.8-4.4.3-6.6-.1-.5-.2-1-.6-1.4-.4-.4-1-.4-1.6-.3-2.3.1-4.7.4-7 .8-.7.1-1.5.3-2 .8-.4.4-.6.8-.8 1.3l-1.5 3.2c-.2.4-.4.9-.4 1.4 0 .5.3 1 .6 1.4 1 1.4 6.1 4.1 7.3 3.6z"
        fill="#ffe0cc"
      />
    </g>
    <g>
      <path
        d="M1576.6 299.4a8 8 0 0 0-2.6 4.8c-.1.8.2 1.6.9 2 .4.3.8.5 1.3.5l1.2-.3 1.6-.7c1.1-.7 2-1.8 1.9-3.1-.1-1.5-1.1-2.9-2.7-2.9-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h.2-.4l.3.1-.4-.1.2.1-.3-.2.2.2-.2-.3.2.4-.2-.4.1.5-.1-.4v.5l.1-.4-.1.4.2-.4-.3.4.2-.3-.5.5.3-.2-1.2.7.4-.1-1 .4h.4-.2.4-.1l.4.1-.1-.1.3.2-.1-.1.2.3-.1-.1.2.4-.1-.3.1.4v-.5l-.1.4.3-1.1-.2.4c.2-.6.6-1.1 1-1.7l-.2.3.8-.9c.6-.5.6-1.6 0-2.1-.7-.9-1.6-.9-2.2-.3z"
        fill="#e5e289"
      />
    </g>
    <g>
      <path
        d="M537.1 250.1c-.5-.5-.7-1.2-.8-1.9s0-1.4 0-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M537 249.9c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M537 249.8c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M537.1 249.6c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M537.1 249.9c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M536.8 250c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M547.1 236.1c-.5-.5-.7-1.2-.8-1.9s0-1.4 0-2.1l.2.3.5 1.1c.4.8.3 1.6.2 2.5"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M547 235.9c-.7.2-1.4 0-2-.2l-1.8-1.1h.3c.4.2.8.1 1.2.1.8.1 1.6.6 2.2 1.1"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M547 235.8c.6.4 1 1 1.2 1.6l.5 2a.2.2 0 0 1-.2-.2l-.8-1c-.5-.6-.7-1.5-.8-2.4M547.1 235.6c.7-.1 1.4 0 2 .3s1.2.7 1.7 1.2h-.3c-.4-.2-.8-.1-1.2-.2-.8-.1-1.5-.6-2.2-1.2"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M547.1 235.9c-.1.7-.5 1.3-.9 1.8l-1.6 1.3c-.1-.1 0-.2.1-.3.3-.3.4-.7.5-1.1.4-.8 1.1-1.3 1.8-1.7"
        fill="#fff"
        opacity=".6"
      />
      <path
        d="M546.8 236c.1-.7.5-1.3 1-1.8s1.1-.9 1.6-1.2c.1.1 0 .2-.1.3-.3.3-.4.7-.6 1.1-.4.8-1.1 1.2-1.8 1.7"
        fill="#fff"
        opacity=".6"
      />
    </g>
    <g>
      <path
        d="M644.9 672.3a127 127 0 0 0 24 20.5c1 .7 2.1 1.4 3.4 1.7 2.5.6 5.2-.5 7.6-1.6l4.5-2.1c.8-.4 1.6-.8 2.1-1.5.7-1 .6-2.3.4-3.5l-2-16c-.3-2.6-.7-5.4-2.4-7.5-1.1-1.4-2.7-2.3-4.2-3.2l-7.3-4.3a30 30 0 0 0-12.3-5c-3.1-.2-6.2.5-9.3 1.3-1.7.5-3.4 1-4.9 1.9-3.5 2.3-4.1 9.7-4.1 9.7-.4 3.6 2.1 6.9 4.5 9.6z"
        fill="#c4afd9"
      />
      <path
        d="M657 670.3c-.4.7-.4 1.6-.4 2.4 0 2.6.6 5.3 2.2 7.4 1.5 2.1 4 3.5 6.7 3.5 3.5-.1 6.4-2.9 7.7-6.2 1.2-3.2 1.1-6.8.8-10.3-.1-.7-.2-1.4-.6-2-.5-.6-1.4-.8-2.2-.9-2.8-.4-6-.6-8.3 1.1a31.2 31.2 0 0 0-5.9 5z"
        fill="#ffe0cc"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "map-svg",
};
</script>

